// src/admin/pages/AdminSettings.js
import React, { useState, useContext, useEffect } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import {
    FaSave,
    FaUpload,
    FaStore,
    FaTruck,
    FaPhone,
    FaEnvelope,
    FaCog,
} from "react-icons/fa";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import {
  getAdminCategoryCards,
  createAdminCategoryCard,
  updateAdminCategoryCard,
  deleteAdminCategoryCard,
  getAdminCategoryCarousel,
  updateAdminCategoryCarouselImage,
  updateAdminCategoryCarouselOrder,
  getAdminCategoryCarouselSection,
updateAdminCategoryCarouselSection,
getAdminAboutPageSettings,
updateAdminAboutPageSettings,
getAdminTermsConditionsSettings,
updateAdminTermsConditionsSettings,
getAdminPrivacyPolicySettings,
updateAdminPrivacyPolicySettings,
getAdminPaymentDeliverySettings,
updateAdminPaymentDeliverySettings,
getAdminReturnsPageSettings,
updateAdminReturnsPageSettings,
getAdminSearchOverlaySettings,
updateAdminSearchOverlaySettings,
getAdminProductsPageFeaturedSection,
updateAdminProductsPageFeaturedSection,
getAdminProductInstagramReelsSection,
updateAdminProductInstagramReelsSection,
getAdminProductLookSection,
updateAdminProductLookSection,
getAdminHeaderOverlayImages,
updateAdminHeaderOverlayImages,
getAdminHomepageCategoryProductRows,
updateAdminHomepageCategoryProductRows,
} from "../../services/adminHomepage.api";
import { getAdminCategoriesWithProducts } from "../../services/adminProducts.api";
import { getAdminProducts  } from "../../services/adminProducts.api";
import { mapBackendProduct } from "../../utils/mapProduct";
import { FaTrash } from "react-icons/fa";
import { uploadAdminLuxuryVideo } from "../../services/adminHomepage.api";
import { uploadAdminFile } from "../../services/adminUpload.api";
import { uploadAdminImage } from "../../services/adminHomepage.api";

const ModalInput = ({ label, value, onChange }) => (
  <>
    <label className="block text-[12px] font-medium text-gray-900 mb-1">
      {label}
    </label>
    <input
      className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
    />
  </>
);

const ModalTextarea = ({ label, value, onChange, rows = 3 }) => (
  <>
    <label className="block text-[12px] font-medium text-gray-900 mb-1">
      {label}
    </label>
    <textarea
      rows={rows}
      className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3 resize-y"
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
    />
  </>
);

function AdminSettings() {
    const [isOpen, setIsOpen] = useState(false);
    const { lang } = useContext(AdminLanguageContext);
    
    const [categoryCards, setCategoryCards] = useState([]);
    const [editing, setEditing] = useState(null);
    
    const [editModal, setEditModal] = useState(null);
    const [categories, setCategories] = useState([]);
    
    const [carouselCategories, setCarouselCategories] = useState([]);
    const [categoryCarouselSection, setCategoryCarouselSection] = useState(null);

const [categoryProductRows, setCategoryProductRows] = useState([]);
const [categoryRowProductSearch, setCategoryRowProductSearch] = useState("");
const [productSearch, setProductSearch] = useState("");
const [productSearchTwo, setProductSearchTwo] = useState("");
const [allProducts, setAllProducts] = useState([]);

const [termsSettings, setTermsSettings] = useState(null);

const [searchOverlaySettings, setSearchOverlaySettings] = useState(null);
const [searchRecommendedProductSearch, setSearchRecommendedProductSearch] = useState("");

const [privacySettings, setPrivacySettings] = useState(null);

const [paymentDeliverySettings, setPaymentDeliverySettings] = useState(null);
const [returnsSettings, setReturnsSettings] = useState(null);

    const [dragIndex, setDragIndex] = useState(null);

    const [confirm, setConfirm] = useState(null);
    const [toast, setToast] = useState("");
    const [uploading, setUploading] = useState(false);

    const [aboutPageSettings, setAboutPageSettings] = useState(null);

    const showToast = (msg) => {
  setToast(msg);
  setTimeout(() => setToast(""), 2500);
};


const CATEGORY_CARD_SPECIALS = [
  { key: "all-products", labelEN: "All Products", labelAR: "كل المنتجات" },
  { key: "new-in", labelEN: "New In", labelAR: "وصل حديثاً" },
  { key: "bestsellers", labelEN: "Bestsellers", labelAR: "الأكثر مبيعاً" },
  { key: "sale", labelEN: "Sale", labelAR: "تخفيضات" },
];

const categoryCardTargetOptions = [
  ...CATEGORY_CARD_SPECIALS,
  ...categories.map((c) => ({
    key: c.slug,
    labelEN: c.name_en,
    labelAR: c.name_ar,
  })),
];


const IMAGE_BASE =
  process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL.replace(/\/api$/, "")
    : "http://localhost:5005";

const resolveImage = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;

  const base =
    process.env.REACT_APP_API_URL?.replace(/\/api$/, "") ||
    window.location.origin;

  return base + url;
};

const isVideoFile = (url = "") => {
  const cleanUrl = String(url).split("?")[0].toLowerCase();
  return /\.(mp4|webm|ogg|mov)$/i.test(cleanUrl);
};

const ProductMediaPreview = ({ src, className = "" }) => {
  const resolvedSrc = resolveImage(src || "/images/placeholder-product.jpg");

  if (isVideoFile(resolvedSrc)) {
    return (
      <video
        src={resolvedSrc}
        muted
        playsInline
        preload="metadata"
        className={className}
      />
    );
  }

  return (
    <img
      src={resolvedSrc}
      alt=""
      className={className}
    />
  );
};


const handleDragStart = (index) => {
  setDragIndex(index);
};

const handleDrop = async (dropIndex) => {
  if (dragIndex === null || dragIndex === dropIndex) return;

  const updated = [...carouselCategories];
  const [moved] = updated.splice(dragIndex, 1);
  updated.splice(dropIndex, 0, moved);

  // reassign sort_order based on new index
  const reordered = updated.map((c, i) => ({
    ...c,
    sort_order: i + 1,
  }));

  setCarouselCategories(reordered);
  setDragIndex(null);

  // 🔥 persist order (sequential, safe)
  for (const c of reordered) {
    await updateAdminCategoryCarouselOrder(c.id, c.sort_order);
  }
};

    const TEXT = {
  EN: {
    title: "Store Settings",
    success: "Settings saved successfully!",
    mobile: "Mobile",
desktop: "Desktop",
clothesOverlayTarget: "Clothes Overlay Target",
shoesOverlayTarget: "Shoes Overlay Target",
accessoriesOverlayTarget: "Accessories Overlay Target",
searchProducts: "Search products...",
selectedProducts: "Selected Products",
searchTag: "Search Tag",
carouselImage: "Carousel Image",
image: "Image",
heroImage: "Hero Image",
accessoriesImage: "Accessories Image",
flatsImage: "Flats Mini Image",
searchOverlay: "Search Overlay",
editSearchOverlay: "Edit Search Overlay",
popularSearchTerms: "Popular Search Terms",
recommendedSearchProducts: "Recommended Search Products",
    // GENERAL
    cancel: "Cancel",
    confirm: "Confirm",
    uploadFailed: "Upload failed",
    edit: "Edit",
    save: "Save",
    delete: "Delete",
    upload: "Upload",
    uploading: "Uploading...",

    // MOBILE BLOCK
    mobileTitle: "This feature is available only on desktop",
    mobileDesc: "Please use a tablet or desktop device to access this page",

    // SECTIONS
    categoryCards: "Homepage – Category Cards",
    shopBySex: "Homepage – Shop By Sex",
    categoryHero: "Homepage – Category Hero",
    featured: "Homepage – Featured Categories",
    accessories: "Homepage – Accessories Section",
    flatsMini: "Homepage – Flats Mini Section",
    carousel: "Homepage – Category Carousel",
    popular: "Homepage – Popular Searches Order",
    luxuryVideos: "Homepage – Luxury Videos",
    privacyPage: "Privacy Policy Page",
    paymentDeliveryPage: "Payment and Delivery Page",
editPaymentDeliveryPage: "Edit Payment and Delivery Page",
paymentDeliveryContentEN: "Payment and Delivery Content (EN)",
paymentDeliveryContentAR: "Payment and Delivery Content (AR)",

returnsPage: "Returns Page",
editReturnsPage: "Edit Returns Page",
returnsContentEN: "Returns Content (EN)",
returnsContentAR: "Returns Content (AR)",
editPrivacyPage: "Edit Privacy Policy Page",
privacyContentEN: "Privacy Policy Content (EN)",
privacyContentAR: "Privacy Policy Content (AR)",

    addVideo: "+ Add Luxury Video",
    aboutPage: "About Us Page",
editAboutPage: "Edit About Us Page",
aboutImageOne: "First Image",
aboutImageTwo: "Second Image",
aboutImageThree: "Third Image",
counterValue: "Counter Value",
productInstagramReels: "Product Details – Instagram Reels",
productLookSection: "Product Details – Products Used In Look",
editProductLookSection: "Edit Products Used In Look",
editProductInstagramReels: "Edit Product Instagram Reels",
instagramReelsTitleEN: "Section Title (EN)",
instagramReelsTitleAR: "Section Title (AR)",
instagramReelUrl: "Instagram Reel Link",
instagramReelLikes: "Likes Number",
addInstagramReel: "+ Add Reel",
counterLabelEN: "Counter Label (EN)",
counterLabelAR: "Counter Label (AR)",
newProductsCounter: "New Products Counter",
completionTimeCounter: "Completion Time Counter",
marketCounter: "On Market Counter",
    editCard: "Edit Category Card",
    editHero: "Edit Category Hero",
    editVideo: "Edit Luxury Video",
    editFeatured: "Edit Featured Category",
    editAccessories: "Edit Accessories Section",
    editFlats: "Edit Flats Mini Section",
    editShop: "Edit Shop By Sex Item",
    aboutTextContent: "About Text Content",
hiEN: "Hi Text (EN)",
hiAR: "Hi Text (AR)",
paragraphOneEN: "First Paragraph (EN)",
paragraphOneAR: "First Paragraph (AR)",
paragraphTwoEN: "Second Paragraph (EN)",
paragraphTwoAR: "Second Paragraph (AR)",
stylingTitleEN: "Styling Title (EN)",
stylingTitleAR: "Styling Title (AR)",
bulletOneEN: "Bullet 1 (EN)",
bulletOneAR: "Bullet 1 (AR)",
bulletTwoEN: "Bullet 2 (EN)",
bulletTwoAR: "Bullet 2 (AR)",
bulletThreeEN: "Bullet 3 (EN)",
bulletThreeAR: "Bullet 3 (AR)",
founderTextEN: "Founder Text (EN)",
founderTextAR: "Founder Text (AR)",
productsPageFeatured: "Products Page – Featured Section",
editProductsPageFeatured: "Edit Products Page Featured Section",
mottoPrefixEN: "Motto Prefix (EN)",
mottoPrefixAR: "Motto Prefix (AR)",
mottoTextEN: "Motto Text (EN)",
headerOverlayImages: "Main Header – Desktop Overlay Images",
editHeaderOverlayImages: "Edit Header Overlay Images",
clothesOverlayImage: "Clothes Overlay Image",
shoesOverlayImage: "Shoes Overlay Image",
accessoriesOverlayImage: "Accessories Overlay Image",
mottoTextAR: "Motto Text (AR)",
termsPage: "Terms and Conditions Page",
editTermsPage: "Edit Terms and Conditions Page",
termsContentEN: "Terms Content (EN)",
termsContentAR: "Terms Content (AR)",
    // FORM
    titleEN: "Title (EN)",
    titleAR: "Title (AR)",
    subtitleEN: "Subtitle (EN)",
    subtitleAR: "Subtitle (AR)",
    category: "Collection",
categoryProductRows: "Homepage – Collection Product Rows",
editCategoryProductRows: "Edit Collection Product Rows",
addCategoryRow: "+ Add Collection Row",
selectCategory: "Select Collection",
    linkCategory: "Link Target Category",
    uploadVideo: "Upload Video",

    deleteVideoConfirm: "Are you sure you want to delete this video?",
    videoDeleted: "Video deleted successfully",
  },

  AR: {
    title: "إعدادات المتجر",
    success: "تم حفظ الإعدادات بنجاح!",
    mobile: "موبايل",
desktop: "كمبيوتر",
termsPage: "صفحة الشروط والأحكام",
editTermsPage: "تعديل صفحة الشروط والأحكام",
termsContentEN: "محتوى الشروط (EN)",
termsContentAR: "محتوى الشروط (AR)",
searchTag: "وسم البحث",
carouselImage: "صورة الكاروسيل",
image: "صورة",
uploadFailed: "فشل رفع الملف",
heroImage: "صورة البانر",
accessoriesImage: "صورة الإكسسوارات",
flatsImage: "صورة فلات ميني",
productInstagramReels: "صفحة المنتج – ريلز إنستغرام",
editProductInstagramReels: "تعديل ريلز إنستغرام للمنتج",
instagramReelsTitleEN: "عنوان القسم (EN)",
instagramReelsTitleAR: "عنوان القسم (AR)",
instagramReelUrl: "رابط ريل إنستغرام",
instagramReelLikes: "عدد الإعجابات",
addInstagramReel: "+ إضافة ريل",
    cancel: "إلغاء",
    confirm: "تأكيد",
    paymentDeliveryPage: "صفحة الدفع والتوصيل",
editPaymentDeliveryPage: "تعديل صفحة الدفع والتوصيل",
paymentDeliveryContentEN: "محتوى الدفع والتوصيل (EN)",
paymentDeliveryContentAR: "محتوى الدفع والتوصيل (AR)",

returnsPage: "صفحة الإرجاع",
editReturnsPage: "تعديل صفحة الإرجاع",
returnsContentEN: "محتوى الإرجاع (EN)",
returnsContentAR: "محتوى الإرجاع (AR)",
    edit: "تعديل",
    save: "حفظ",
    delete: "حذف",
    upload: "رفع",
    uploading: "جارٍ الرفع...",
searchProducts: "ابحث عن المنتجات...",
selectedProducts: "المنتجات المختارة",

    mobileTitle: "هذه الميزة متاحة فقط على أجهزة الكمبيوتر",
    mobileDesc: "يرجى استخدام جهاز لوحي أو كمبيوتر للوصول إلى هذه الصفحة",

    categoryCards: "الصفحة الرئيسية – بطاقات التصنيفات",
    shopBySex: "الصفحة الرئيسية – التسوق حسب الجنس",
    categoryHero: "الصفحة الرئيسية – بانر التصنيفات",
    featured: "الصفحة الرئيسية – التصنيفات المميزة",
    accessories: "الصفحة الرئيسية – قسم الإكسسوارات",
    flatsMini: "الصفحة الرئيسية – قسم فلات ميني",
    carousel: "الصفحة الرئيسية – شريط التصنيفات",
    popular: "الصفحة الرئيسية – ترتيب البحث الشائع",
    luxuryVideos: "الصفحة الرئيسية – فيديوهات فاخرة",
searchOverlay: "Search Overlay",
editSearchOverlay: "Edit Search Overlay",
popularSearchTerms: "Popular Search Terms",
recommendedSearchProducts: "Recommended Search Products",
    addVideo: "+ إضافة فيديو",
    aboutPage: "صفحة من نحن",
editAboutPage: "تعديل صفحة من نحن",
aboutImageOne: "الصورة الأولى",
aboutImageTwo: "الصورة الثانية",
aboutImageThree: "الصورة الثالثة",
counterValue: "قيمة العداد",
counterLabelEN: "عنوان العداد (EN)",
counterLabelAR: "عنوان العداد (AR)",
newProductsCounter: "عداد المنتجات الجديدة",
completionTimeCounter: "عداد مدة تجهيز الطلب",
marketCounter: "عداد مدة الوجود في السوق",
    editCard: "تعديل البطاقة",
    editHero: "تعديل البانر",
    clothesOverlayTarget: "رابط صورة قائمة الملابس",
shoesOverlayTarget: "رابط صورة قائمة الأحذية",
accessoriesOverlayTarget: "رابط صورة قائمة الإكسسوارات",
    editVideo: "تعديل الفيديو",
    aboutTextContent: "محتوى نص صفحة من نحن",
hiEN: "نص الترحيب (EN)",
hiAR: "نص الترحيب (AR)",
category: "المجموعة",
categoryProductRows: "الصفحة الرئيسية – صفوف منتجات المجموعات",
editCategoryProductRows: "تعديل صفوف منتجات المجموعات",
addCategoryRow: "+ إضافة صف مجموعة",
selectCategory: "اختر مجموعة",
paragraphOneEN: "الفقرة الأولى (EN)",
paragraphOneAR: "الفقرة الأولى (AR)",
paragraphTwoEN: "الفقرة الثانية (EN)",
paragraphTwoAR: "الفقرة الثانية (AR)",
productLookSection: "صفحة المنتج – المنتجات المستخدمة في الإطلالة",
editProductLookSection: "تعديل المنتجات المستخدمة في الإطلالة",
stylingTitleEN: "عنوان الستايلات (EN)",
stylingTitleAR: "عنوان الستايلات (AR)",
headerOverlayImages: "الهيدر الرئيسي – صور القوائم على الكمبيوتر",
editHeaderOverlayImages: "تعديل صور قوائم الهيدر",
clothesOverlayImage: "صورة قائمة الملابس",
shoesOverlayImage: "صورة قائمة الأحذية",
accessoriesOverlayImage: "صورة قائمة الإكسسوارات",
productsPageFeatured: "صفحة المنتجات – قسم المنتجات المميزة",
editProductsPageFeatured: "تعديل قسم صفحة المنتجات",
bulletOneEN: "النقطة الأولى (EN)",
bulletOneAR: "النقطة الأولى (AR)",
privacyPage: "صفحة سياسة الخصوصية",
editPrivacyPage: "تعديل صفحة سياسة الخصوصية",
privacyContentEN: "محتوى سياسة الخصوصية (EN)",
privacyContentAR: "محتوى سياسة الخصوصية (AR)",
bulletTwoEN: "النقطة الثانية (EN)",
bulletTwoAR: "النقطة الثانية (AR)",
bulletThreeEN: "النقطة الثالثة (EN)",
bulletThreeAR: "النقطة الثالثة (AR)",
founderTextEN: "نص المؤسس (EN)",
founderTextAR: "نص المؤسس (AR)",
mottoPrefixEN: "مقدمة الشعار (EN)",
mottoPrefixAR: "مقدمة الشعار (AR)",
mottoTextEN: "نص الشعار (EN)",
mottoTextAR: "نص الشعار (AR)",
    editFeatured: "تعديل التصنيف المميز",
    editAccessories: "تعديل قسم الإكسسوارات",
    editFlats: "تعديل فلات ميني",
    editShop: "تعديل العنصر",

    titleEN: "العنوان (EN)",
    titleAR: "العنوان (AR)",
    subtitleEN: "الوصف (EN)",
    subtitleAR: "الوصف (AR)",
    linkCategory: "رابط التصنيف",
    uploadVideo: "رفع فيديو",

    deleteVideoConfirm: "هل أنت متأكد من حذف هذا الفيديو؟",
    videoDeleted: "تم حذف الفيديو بنجاح",
  },
}[lang];

    const [storeName, setStoreName] = useState("ETIKA");
    const [email, setEmail] = useState("support@example.com");
    const [phone, setPhone] = useState("+123456789");
    const [deliveryFee, setDeliveryFee] = useState(5);
    const [logo, setLogo] = useState(null);

    const [productsPageFeatured, setProductsPageFeatured] = useState(null);
const [productsPageFeaturedSearch, setProductsPageFeaturedSearch] = useState("");
const [productInstagramReels, setProductInstagramReels] = useState(null);

const [productLookSection, setProductLookSection] = useState(null);
const [headerOverlayImages, setHeaderOverlayImages] = useState(null);

    const [success, setSuccess] = useState("");

    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogo(URL.createObjectURL(file)); // TEMP preview only
        }
    };

    const saveSettings = () => {
        setSuccess(TEXT.success);
        setTimeout(() => setSuccess(""), 1500);
    };

    useEffect(() => {
  getAdminHomepageCategoryProductRows()
    .then((rows) => setCategoryProductRows(Array.isArray(rows) ? rows : []))
    .catch(() => {});
}, []);

    useEffect(() => {
  getAdminHeaderOverlayImages()
    .then(setHeaderOverlayImages)
    .catch(() => {});
}, []);

    useEffect(() => {
  getAdminProductsPageFeaturedSection()
    .then(setProductsPageFeatured)
    .catch(() => {});
}, []);

useEffect(() => {
  getAdminProductInstagramReelsSection()
    .then(setProductInstagramReels)
    .catch(() => {});
}, []);

useEffect(() => {
  getAdminProductLookSection()
    .then(setProductLookSection)
    .catch(() => {});
}, []);

useEffect(() => {
  getAdminTermsConditionsSettings()
    .then(setTermsSettings)
    .catch(() => {});
}, []);

useEffect(() => {
  getAdminPrivacyPolicySettings()
    .then(setPrivacySettings)
    .catch(() => {});
}, []);

useEffect(() => {
  getAdminPaymentDeliverySettings()
    .then(setPaymentDeliverySettings)
    .catch(() => {});
}, []);

useEffect(() => {
  getAdminSearchOverlaySettings()
    .then(setSearchOverlaySettings)
    .catch(() => {});
}, []);

useEffect(() => {
  getAdminReturnsPageSettings()
    .then(setReturnsSettings)
    .catch(() => {});
}, []);

useEffect(() => {
  getAdminAboutPageSettings()
    .then(setAboutPageSettings)
    .catch(() => {});
}, []);


useEffect(() => {
  getAdminProducts()
    .then((rows) => setAllProducts(Array.isArray(rows) ? rows : []))
    .catch(() => {});
}, []);


    useEffect(() => {
  getAdminCategoriesWithProducts()
    .then(setCategories)
    .catch(() => {});
}, []);

useEffect(() => {
  getAdminCategoryCards().then(setCategoryCards);
}, []);


useEffect(() => {
  getAdminCategoryCarouselSection()
    .then(setCategoryCarouselSection)
    .catch(() => {});
}, []);

useEffect(() => {
  getAdminCategoryCarousel().then(setCarouselCategories).catch(() => {});
}, []);


useEffect(() => {
  async function enrichImages() {
    const allProducts = await getAdminProducts();

    const updated = await Promise.all(
      carouselCategories.map(async (c) => {
        // keep admin override
        if (c.image_url) return c;

        try {
          const filtered = allProducts.filter((p) =>
            (p.categories || []).includes(c.slug)
          );

          const mapped = filtered
            .map(mapBackendProduct)
            .sort(
              (a, b) => new Date(b.created_at) - new Date(a.created_at)
            );

          return {
            ...c,
            image_url:
              mapped[0]?.images?.[0] || "/images/placeholder-product.jpg",
          };
        } catch {
          return c;
        }
      })
    );

    setCarouselCategories(updated);
  }

  if (carouselCategories.length) enrichImages();
}, [carouselCategories.length]);


const ImageUploadField = ({
  label,
  value,
  onChange,
  accept = "image/*",
  helper = "",
}) => {
  return (
    <div className="mb-3">
      <label className="block text-[12px] font-medium text-gray-600 text-gray-900 mb-1">
        {label}
      </label>
{helper && (
  <div className="mb-2 text-[11px] font-medium text-gray-500">
    {helper}
  </div>
)}
      <input
        type="file"
        accept={accept}
        className="hidden"
        id={`upload-${label}`}
        onChange={async (e) => {
          const file = e.target.files?.[0];
          if (!file) return;

          setUploading(true);
          try {
            const uploaded = await uploadAdminImage(file);
            onChange(uploaded.url);
          } catch (err) {
            alert(err.message || TEXT.uploadFailed);
          } finally {
            setUploading(false);
          }
        }}
      />

      <label
        htmlFor={`upload-${label}`}
        className="
              inline-flex items-center gap-2
              px-3 py-1.5
              rounded-md
              border border-gray-300
              bg-gray-50
              text-gray-900
              text-[12px] font-medium
              hover:bg-gray-100
              active:scale-[0.98]
              transition
            "
      >
        <FaUpload className="text-[12px]" />
        {uploading ? TEXT.uploading : TEXT.upload}
      </label>

      {value && (
        <img
          src={resolveImage(value)}
          alt="preview"
          className="mt-2 h-24 object-contain bg-gray-50 rounded-md border"
        />
      )}
    </div>
  );
};

const HeaderOverlayTargetSelect = ({ label, value, onChange }) => (
  <div className="mb-3">
    <label className="block text-[12px] font-medium text-gray-900 mb-1">
      {label}
    </label>

    <select
      className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3 bg-white"
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">
        {lang === "AR" ? "اختر الرابط" : "Select target"}
      </option>

      {categoryCardTargetOptions.map((item) => (
        <option key={item.key} value={item.key}>
          {lang === "AR" ? item.labelAR : item.labelEN} ({item.key})
        </option>
      ))}
    </select>
  </div>
);

const selectedProductsPageFeaturedIds = Array.isArray(productsPageFeatured?.products)
  ? productsPageFeatured.products.map((p) => Number(p.id))
  : [];

  const productBelongsToCollection = (product, selectedCategory) => {
  if (!product || !selectedCategory) return false;

  const productCategories = Array.isArray(product.categories)
    ? product.categories
    : [];

  return productCategories.some((cat) => {
    if (typeof cat === "string") {
      return (
        String(cat).toLowerCase() ===
        String(selectedCategory.slug).toLowerCase()
      );
    }

    return (
      Number(cat.id) === Number(selectedCategory.id) ||
      String(cat.slug || "").toLowerCase() ===
        String(selectedCategory.slug).toLowerCase()
    );
  });
};

  const normalizeCategoryProductRowsForModal = (rows = []) =>
  rows.map((row, index) => ({
    category_id: Number(row.category_id),
    sort_order: Number(row.sort_order || index + 1),
    product_ids: Array.isArray(row.products)
      ? row.products.map((p) => Number(p.id)).filter(Boolean)
      : Array.isArray(row.product_ids)
      ? row.product_ids.map(Number).filter(Boolean)
      : [],
  }));

const filteredProductsPageFeaturedProducts = allProducts
  .filter((p) => p.status !== "archived")
  .filter((p) => {
    const q = productsPageFeaturedSearch.trim().toLowerCase();
    if (!q) return true;

    return (
      String(p.id || "").includes(q) ||
      String(p.public_id || "").toLowerCase().includes(q) ||
      String(p.name_en || "").toLowerCase().includes(q) ||
      String(p.name_ar || "").toLowerCase().includes(q) ||
      String(p.seo_slug || "").toLowerCase().includes(q)
    );
  })
  .slice(0, 80);

    return (
        <div className={`flex bg-[#f1f1f1] min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
            <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

            <div className={`flex-1 min-w-0 transition-all duration-300 ${
  lang === "AR" ? "" : "lg:ml-64"
}`}
>
                <AdminHeader setIsOpen={setIsOpen} />

                <main
  dir={lang === "AR" ? "rtl" : "ltr"}
  className="p-4 sm:p-6 animate-fadeSlide w-full max-w-full overflow-x-hidden"
>

         
<div>
  {/* HEADER */}
<div
  className={`
    flex items-center gap-2 mb-4 sm:mb-5
    ${lang === "AR" ? "flex-row-reverse justify-end text-right" : ""}
  `}
>
  <FaCog className="text-gray-900 text-[16px] sm:text-[18px]" />

  <h1 className="text-[18px] sm:text-[20px] font-semibold text-gray-900">
    {TEXT.title}
  </h1>
</div>
            
<div className="flex items-center justify-between mt-10 mb-4">
  <h2 className="text-[16px] sm:text-[18px] font-semibold text-gray-900">
    {TEXT.categoryCards}
  </h2>

  <button
    className="px-3 py-2 rounded-lg bg-black text-white text-sm font-medium hover:bg-gray-800"
    onClick={() =>
      setEditModal({
        type: "card",
        isNew: true,
        data: {
          title_en: "",
          title_ar: "",
          key: "",
          mobile_image: "",
          desktop_image: "",
        },
      })
    }
  >
    {lang === "AR" ? "+ إضافة سلايدر" : "+ Add Slider"}
  </button>
</div>

<div className="flex flex-wrap gap-4 pb-2 w-full max-w-full">
  {categoryCards.map((c) => (
    <div
      key={c.id}
      className="relative bg-white border border-[#e3e3e3] rounded-[14px] shadow-[0_8px_20px_rgba(0,0,0,0.06)] p-3 sm:p-4 flex flex-col w-full sm:w-[calc(50%-8px)] xl:w-[calc(25%-12px)] min-w-[260px]"
    >
      <button
        onClick={() => {
          setConfirm({
            message:
              lang === "AR"
                ? "هل أنت متأكد من حذف هذا السلايدر؟"
                : "Are you sure you want to delete this slider?",
            onConfirm: async () => {
              await deleteAdminCategoryCard(c.id);
              setCategoryCards((prev) => prev.filter((x) => x.id !== c.id));
              setConfirm(null);
              showToast(lang === "AR" ? "تم حذف السلايدر" : "Slider deleted");
            },
          });
        }}
        className="
          absolute top-2 right-2
          w-8 h-8 rounded-full
          bg-red-500 hover:bg-red-600
          text-white
          flex items-center justify-center
          z-10
        "
        title={TEXT.delete}
      >
        <FaTrash size={12} />
      </button>

      <div className="grid grid-cols-2 gap-2">
        <div>
          <div className="text-[10px] text-gray-400 mb-1">{TEXT.mobile}</div>
          <img
            src={resolveImage(c.mobile_image)}
            alt=""
            className="w-full max-w-full aspect-square object-contain bg-gray-50 rounded border"
          />
        </div>

        <div>
          <div className="text-[10px] text-gray-400 mb-1">{TEXT.desktop}</div>
          <img
            src={resolveImage(c.desktop_image)}
            alt=""
            className="w-full max-w-full aspect-square object-contain bg-gray-50 rounded border"
          />
        </div>
      </div>

      <p className="mt-2 font-semibold text-[13px] sm:text-[14px]">{c.title_en}</p>
      <p className="text-sm text-gray-500 leading-snug">{c.title_ar}</p>

      <div className="mt-1 text-[11px] text-gray-400">
        {lang === "AR" ? "الهدف:" : "Target:"} {c.key || "—"}
      </div>

      <button
        className="mt-2 text-gray-900 font-medium text-sm hover:text-black"
        onClick={() => setEditModal({ type: "card", data: { ...c } })}
      >
        {TEXT.edit}
      </button>
    </div>
  ))}
</div>

<div className="flex items-center justify-between mt-8 mb-3">
  <h2 className="text-[16px] sm:text-[18px] font-semibold text-gray-900">
    {TEXT.carousel}
  </h2>

  {categoryCarouselSection && (
    <button
      className="px-3 py-1.5 rounded-md border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50"
      onClick={() =>
        setEditModal({
          type: "carouselTitle",
          data: { ...categoryCarouselSection },
        })
      }
    >
      {lang === "AR" ? "تعديل العنوان" : "Edit Title"}
    </button>
  )}
</div>

<div className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-[0_8px_20px_rgba(0,0,0,0.06)] p-3 sm:p-4 flex flex-col w-full">
  <div className="flex gap-3 sm:gap-4 overflow-x-auto scrollbar-hide px-1 w-full max-w-full">
    {carouselCategories
  .slice()
  .sort((a, b) => a.sort_order - b.sort_order)
  .map((c, index) => (
    <div
      key={c.id}
      draggable
      onDragStart={() => handleDragStart(index)}
      onDragOver={(e) => e.preventDefault()}
      onDrop={() => handleDrop(index)}
      className="
        flex flex-col items-center min-w-[90px]
        cursor-move
        group
      "
    >
      {/* ORDER BADGE */}
      <div className="mb-1 text-xs font-bold text-white bg-gray-800 rounded-full w-6 h-6 flex items-center justify-center">
        {index + 1}
      </div>

      {/* RING */}
      <div className="p-[2px] rounded-full bg-gradient-to-tr from-pink-500 via-red-500 to-yellow-400 group-hover:scale-105 transition">
        <div className="bg-white p-[2px] rounded-full">
          <img
            src={resolveImage(c.image_url) || "/images/cat-heels.jpg"}
            alt={c.name_en}
            className="w-[70px] h-[70px] object-contain bg-gray-50 rounded-full"
          />
        </div>
      </div>

      {/* NAME */}
      <span className="mt-2 text-xs font-medium text-center truncate max-w-[80px]">
        {lang === "AR" ? c.name_ar : c.name_en}
      </span>

      {/* SLUG */}
      <span className="text-[10px] text-gray-400 truncate max-w-[80px]">
        {c.slug}
      </span>
      <button
  type="button"
  className="mt-2 text-[11px] font-medium text-gray-900 hover:text-black"
  onClick={() =>
    setEditModal({
      type: "carousel",
      data: { ...c },
    })
  }
>
  {TEXT.edit}
</button>
    </div>
))}
  </div>
</div>

<div className="flex items-center justify-between mt-8 mb-3">
  <h2 className="text-[16px] sm:text-[18px] font-semibold text-gray-900">
    {TEXT.headerOverlayImages}
  </h2>

  {headerOverlayImages && (
    <button
      className="px-3 py-1.5 rounded-md border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50"
      onClick={() =>
        setEditModal({
          type: "headerOverlayImages",
          data: {
  clothes: {
    image_url: headerOverlayImages.clothes?.image_url || "",
    link_target: headerOverlayImages.clothes?.link_target || "",
  },
  shoes: {
    image_url: headerOverlayImages.shoes?.image_url || "",
    link_target: headerOverlayImages.shoes?.link_target || "",
  },
  accessories: {
    image_url: headerOverlayImages.accessories?.image_url || "",
    link_target: headerOverlayImages.accessories?.link_target || "",
  },
},
        })
      }
    >
      {TEXT.edit}
    </button>
  )}
</div>

{headerOverlayImages && (
  <div className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-[0_8px_20px_rgba(0,0,0,0.06)] p-3 sm:p-4 flex flex-col w-full">
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      {[
        {
          key: "clothes",
          label: lang === "AR" ? "ملابس" : "Clothes",
        },
        {
          key: "shoes",
          label: lang === "AR" ? "أحذية" : "Shoes",
        },
        {
          key: "accessories",
          label: lang === "AR" ? "إكسسوارات" : "Accessories",
        },
      ].map((item) => (
        <div key={item.key} className="border rounded-lg p-2 bg-gray-50">
          <p className="mb-2 text-xs font-semibold text-gray-900">
            {item.label}
          </p>

          {headerOverlayImages[item.key]?.image_url ? (
  <>
    <img
      src={resolveImage(headerOverlayImages[item.key].image_url)}
      alt=""
      className="w-full aspect-[4/3] object-cover bg-white rounded"
    />

    <p className="mt-2 text-[11px] text-gray-500">
      {lang === "AR" ? "الرابط:" : "Target:"}{" "}
      <span className="font-semibold text-gray-900">
        {headerOverlayImages[item.key]?.link_target || "—"}
      </span>
    </p>
  </>
) : (
            <div className="w-full aspect-[4/3] rounded bg-white border border-dashed border-gray-300 flex items-center justify-center text-xs text-gray-400">
              {lang === "AR" ? "لا توجد صورة" : "No image"}
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
)}


<div className="flex items-center justify-between mt-8 mb-3">
  <h2 className="text-[16px] sm:text-[18px] font-semibold text-gray-900">
    {TEXT.categoryProductRows}
  </h2>

  <button
    className="px-3 py-1.5 rounded-md border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50"
    onClick={() =>
      setEditModal({
        type: "categoryProductRows",
        data: {
          rows: normalizeCategoryProductRowsForModal(categoryProductRows),
        },
      })
    }
  >
    {TEXT.edit}
  </button>
</div>

<div className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-[0_8px_20px_rgba(0,0,0,0.06)] p-3 sm:p-4 flex flex-col w-full">
  {categoryProductRows.length > 0 ? (
    <div className="space-y-4">
      {categoryProductRows.map((row, rowIndex) => (
        <div key={row.row_id || row.category_id} className="border rounded-xl p-3 bg-gray-50">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="font-semibold text-[13px] sm:text-[14px]">
                #{rowIndex + 1}{" "}
                {lang === "AR" ? row.name_ar : row.name_en}
              </p>

              <p className="text-[11px] text-gray-400">
                {row.slug}
              </p>
            </div>

            <p className="text-xs text-gray-500">
              {(row.products || []).length}{" "}
              {lang === "AR" ? "منتجات" : "products"}
            </p>
          </div>

          <div className="mt-3 grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-3">
            {(row.products || []).slice(0, 6).map((p) => (
              <div key={p.id} className="border rounded-lg p-2 bg-white">
                <ProductMediaPreview
                  src={
                    Array.isArray(p.images)
                      ? p.images[0]
                      : p.image || "/images/placeholder-product.jpg"
                  }
                  className="w-full aspect-square object-contain bg-gray-50 rounded"
                />

                <p className="mt-2 text-xs font-medium line-clamp-2">
                  {lang === "AR" ? p.name_ar : p.name_en}
                </p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  ) : (
    <div className="rounded-xl border border-dashed border-gray-300 bg-gray-50 p-5 text-center">
      <p className="text-sm text-gray-500">
        {lang === "AR"
  ? "لا توجد صفوف مجموعات حالياً"
  : "No collection product rows added yet"}
      </p>

      <button
        type="button"
        className="mt-3 px-4 py-2 rounded-md bg-black text-white text-sm font-medium hover:bg-gray-800"
        onClick={() =>
          setEditModal({
            type: "categoryProductRows",
            data: { rows: [] },
          })
        }
      >
        {TEXT.addCategoryRow}
      </button>
    </div>
  )}
</div>

<div className="flex items-center justify-between mt-8 mb-3">
  <h2 className="text-[16px] sm:text-[18px] font-semibold text-gray-900">
    {TEXT.productsPageFeatured}
  </h2>

  {productsPageFeatured && (
    <button
      className="px-3 py-1.5 rounded-md border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50"
      onClick={() =>
        setEditModal({
          type: "productsPageFeatured",
          data: {
            ...productsPageFeatured,
            product_ids: selectedProductsPageFeaturedIds,
          },
        })
      }
    >
      {TEXT.edit}
    </button>
  )}
</div>

{productsPageFeatured && (
  <div className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-[0_8px_20px_rgba(0,0,0,0.06)] p-3 sm:p-4 flex flex-col w-full">
    <p className="font-semibold text-[13px] sm:text-[14px]">
      {lang === "AR"
        ? productsPageFeatured.title_ar
        : productsPageFeatured.title_en}
    </p>

    <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-3">
      {(productsPageFeatured.products || []).map((p) => (
        <div key={p.id} className="border rounded-lg p-2 bg-gray-50">
          <ProductMediaPreview
            src={
              Array.isArray(p.images)
                ? p.images[0]
                : p.image || "/images/placeholder-product.jpg"
            }
            className="w-full aspect-square object-contain bg-white rounded"
          />

          <p className="mt-2 text-xs font-medium line-clamp-2">
            {lang === "AR" ? p.name_ar : p.name_en}
          </p>
        </div>
      ))}
    </div>
  </div>
)}

<div className="flex items-center justify-between mt-8 mb-3">
  <h2 className="text-[16px] sm:text-[18px] font-semibold text-gray-900">
    {TEXT.productInstagramReels}
  </h2>

  {productInstagramReels && (
    <button
      className="px-3 py-1.5 rounded-md border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50"
      onClick={() =>
        setEditModal({
          type: "productInstagramReels",
          data: {
            title_en:
              productInstagramReels.title_en || "See us on social media❤️",
            title_ar:
              productInstagramReels.title_ar || "شاهدونا على السوشيال ميديا❤️",
            reels: Array.isArray(productInstagramReels.reels)
              ? productInstagramReels.reels
              : [],
          },
        })
      }
    >
      {TEXT.edit}
    </button>
  )}
</div>

{productInstagramReels && (
  <div className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-[0_8px_20px_rgba(0,0,0,0.06)] p-3 sm:p-4 flex flex-col w-full">
    <p className="font-semibold text-[13px] sm:text-[14px]">
      {lang === "AR"
        ? productInstagramReels.title_ar
        : productInstagramReels.title_en}
    </p>

    <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-3">
      {(productInstagramReels.reels || []).map((reel, index) => (
        <div
          key={`${reel.video_url}-${index}`}
          className="border rounded-lg p-2 bg-gray-50"
        >
          {reel.video_url ? (
            <video
              src={resolveImage(reel.video_url)}
              muted
              playsInline
              preload="metadata"
              className="w-full aspect-[9/16] object-cover bg-black rounded"
            />
          ) : (
            <div className="w-full aspect-[9/16] bg-gray-200 rounded flex items-center justify-center text-xs text-gray-500">
              No video
            </div>
          )}

          <p className="mt-2 text-xs font-medium text-gray-900 truncate">
            {reel.reel_url || "—"}
          </p>

          <p className="mt-1 text-xs text-gray-500">
            {lang === "AR" ? "الإعجابات:" : "Likes:"}{" "}
            <span className="font-semibold text-gray-900">
              {reel.likes || "—"}
            </span>
          </p>
        </div>
      ))}

      {(!productInstagramReels.reels ||
        productInstagramReels.reels.length === 0) && (
        <div className="text-sm text-gray-500">
          {lang === "AR" ? "لا توجد ريلز حالياً" : "No reels added yet"}
        </div>
      )}
    </div>
  </div>
)}

<div className="flex items-center justify-between mt-8 mb-3">
  <h2 className="text-[16px] sm:text-[18px] font-semibold text-gray-900">
    {TEXT.productLookSection}
  </h2>

  {productLookSection && (
    <button
      className="px-3 py-1.5 rounded-md border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50"
      onClick={() =>
  setEditModal({
    type: "productLookSection",
    data: {
      title_en: productLookSection.title_en || "",
      title_ar: productLookSection.title_ar || "",
    },
  })
}
    >
      {TEXT.edit}
    </button>
  )}
</div>

{productLookSection && (
  <div className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-[0_8px_20px_rgba(0,0,0,0.06)] p-3 sm:p-4 flex flex-col w-full">
    <p className="font-semibold text-[13px] sm:text-[14px]">
      {lang === "AR"
        ? productLookSection.title_ar
        : productLookSection.title_en}
    </p>

    <p className="mt-2 text-sm text-gray-500 leading-snug">
      {lang === "AR"
        ? "يتم عرض المنتجات تلقائياً حسب تصنيف ووسوم المنتج الحالي."
        : "Products are shown automatically based on the current product category and tags."}
    </p>
  </div>
)}

<div className="flex items-center justify-between mt-8 mb-3">
  <h2 className="text-[16px] sm:text-[18px] font-semibold text-gray-900">
    {TEXT.searchOverlay}
  </h2>

  {searchOverlaySettings && (
    <button
      className="px-3 py-1.5 rounded-md border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50"
      onClick={() =>
        setEditModal({
          type: "searchOverlay",
          data: {
            popular_terms: searchOverlaySettings.popular_terms || [],
            product_ids: (searchOverlaySettings.recommended_products || []).map((p) =>
              Number(p.id)
            ),
          },
        })
      }
    >
      {TEXT.edit}
    </button>
  )}
</div>

{searchOverlaySettings && (
  <div className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-[0_8px_20px_rgba(0,0,0,0.06)] p-3 sm:p-4 flex flex-col w-full">
    <p className="text-sm text-gray-600">
      {TEXT.popularSearchTerms}:{" "}
      <span className="font-semibold">
        {(searchOverlaySettings.popular_terms || []).join(", ") || "—"}
      </span>
    </p>

    <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-3">
      {(searchOverlaySettings.recommended_products || []).map((p) => (
        <div key={p.id} className="border rounded-lg p-2 bg-gray-50">
          <ProductMediaPreview
            src={
              Array.isArray(p.images)
                ? p.images[0]
                : p.image || "/images/placeholder-product.jpg"
            }
            className="w-full aspect-square object-contain bg-white rounded"
          />

          <p className="mt-2 text-xs font-medium line-clamp-2">
            {lang === "AR" ? p.name_ar : p.name_en}
          </p>
        </div>
      ))}
    </div>
  </div>
)}

<div className="flex items-center justify-between mt-8 mb-3">
  <h2 className="text-[16px] sm:text-[18px] font-semibold text-gray-900">
    {TEXT.aboutPage}
  </h2>

  {aboutPageSettings && (
    <button
      className="px-3 py-1.5 rounded-md border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50"
      onClick={() =>
        setEditModal({
          type: "aboutPage",
          data: { ...aboutPageSettings },
        })
      }
    >
      {TEXT.edit}
    </button>
  )}
</div>

{aboutPageSettings && (
  <div className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-[0_8px_20px_rgba(0,0,0,0.06)] p-3 sm:p-4 flex flex-col w-full">
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      {[aboutPageSettings.image_1, aboutPageSettings.image_2, aboutPageSettings.image_3].map(
        (img, index) => (
          <img
            key={index}
            src={resolveImage(img || "/images/placeholder-product.jpg")}
            alt=""
            className="w-full aspect-[4/3] object-contain bg-gray-50 rounded border"
          />
        )
      )}
    </div>

    <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-3">
      <div className="border rounded-lg p-3 bg-gray-50">
        <p className="font-bold text-sm">
          {aboutPageSettings.new_products_value}
        </p>
        <p className="text-xs text-gray-500">
          {lang === "AR"
            ? aboutPageSettings.new_products_label_ar
            : aboutPageSettings.new_products_label_en}
        </p>
      </div>

      <div className="border rounded-lg p-3 bg-gray-50">
        <p className="font-bold text-sm">
          {aboutPageSettings.completion_time_value}
        </p>
        <p className="text-xs text-gray-500">
          {lang === "AR"
            ? aboutPageSettings.completion_time_label_ar
            : aboutPageSettings.completion_time_label_en}
        </p>
      </div>

      <div className="border rounded-lg p-3 bg-gray-50">
        <p className="font-bold text-sm">
          {aboutPageSettings.market_value}
        </p>
        <p className="text-xs text-gray-500">
          {lang === "AR"
            ? aboutPageSettings.market_label_ar
            : aboutPageSettings.market_label_en}
        </p>
      </div>
    </div>
  </div>
)}

<div className="flex items-center justify-between mt-8 mb-3">
  <h2 className="text-[16px] sm:text-[18px] font-semibold text-gray-900">
    {TEXT.termsPage}
  </h2>

  {termsSettings && (
    <button
      className="px-3 py-1.5 rounded-md border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50"
      onClick={() =>
        setEditModal({
          type: "termsPage",
          data: { ...termsSettings },
        })
      }
    >
      {TEXT.edit}
    </button>
  )}
</div>

{termsSettings && (
  <div className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-[0_8px_20px_rgba(0,0,0,0.06)] p-3 sm:p-4 flex flex-col w-full">
    <p className="font-semibold text-[13px] sm:text-[14px]">
      {lang === "AR" ? termsSettings.title_ar : termsSettings.title_en}
    </p>

    <p className="text-sm text-gray-500 leading-6 mt-2 line-clamp-5 whitespace-pre-line">
      {lang === "AR" ? termsSettings.content_ar : termsSettings.content_en}
    </p>
  </div>
)}

<div className="flex items-center justify-between mt-8 mb-3">
  <h2 className="text-[16px] sm:text-[18px] font-semibold text-gray-900">
    {TEXT.privacyPage}
  </h2>

  {privacySettings && (
    <button
      className="px-3 py-1.5 rounded-md border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50"
      onClick={() =>
        setEditModal({
          type: "privacyPage",
          data: { ...privacySettings },
        })
      }
    >
      {TEXT.edit}
    </button>
  )}
</div>

{privacySettings && (
  <div className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-[0_8px_20px_rgba(0,0,0,0.06)] p-3 sm:p-4 flex flex-col w-full">
    <p className="font-semibold text-[13px] sm:text-[14px]">
      {lang === "AR" ? privacySettings.title_ar : privacySettings.title_en}
    </p>

    <p className="text-sm text-gray-500 leading-6 mt-2 line-clamp-5 whitespace-pre-line">
      {lang === "AR" ? privacySettings.content_ar : privacySettings.content_en}
    </p>
  </div>
)}

<div className="flex items-center justify-between mt-8 mb-3">
  <h2 className="text-[16px] sm:text-[18px] font-semibold text-gray-900">
    {TEXT.paymentDeliveryPage}
  </h2>

  {paymentDeliverySettings && (
    <button
      className="px-3 py-1.5 rounded-md border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50"
      onClick={() =>
        setEditModal({
          type: "paymentDeliveryPage",
          data: { ...paymentDeliverySettings },
        })
      }
    >
      {TEXT.edit}
    </button>
  )}
</div>

{paymentDeliverySettings && (
  <div className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-[0_8px_20px_rgba(0,0,0,0.06)] p-3 sm:p-4 flex flex-col w-full">
    <p className="font-semibold text-[13px] sm:text-[14px]">
      {lang === "AR"
        ? paymentDeliverySettings.title_ar
        : paymentDeliverySettings.title_en}
    </p>

    <p className="text-sm text-gray-500 leading-6 mt-2 line-clamp-5 whitespace-pre-line">
      {lang === "AR"
        ? paymentDeliverySettings.content_ar
        : paymentDeliverySettings.content_en}
    </p>
  </div>
)}

<div className="flex items-center justify-between mt-8 mb-3">
  <h2 className="text-[16px] sm:text-[18px] font-semibold text-gray-900">
    {TEXT.returnsPage}
  </h2>

  {returnsSettings && (
    <button
      className="px-3 py-1.5 rounded-md border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50"
      onClick={() =>
        setEditModal({
          type: "returnsPage",
          data: { ...returnsSettings },
        })
      }
    >
      {TEXT.edit}
    </button>
  )}
</div>

{returnsSettings && (
  <div className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-[0_8px_20px_rgba(0,0,0,0.06)] p-3 sm:p-4 flex flex-col w-full">
    <p className="font-semibold text-[13px] sm:text-[14px]">
      {lang === "AR" ? returnsSettings.title_ar : returnsSettings.title_en}
    </p>

    <p className="text-sm text-gray-500 leading-6 mt-2 line-clamp-5 whitespace-pre-line">
      {lang === "AR" ? returnsSettings.content_ar : returnsSettings.content_en}
    </p>
  </div>
)}


              {editModal && (
  <div className="fixed inset-0 bg-black/40 z-50 flex items-end sm:items-center justify-center px-4">
  <div className="
  bg-white
  w-full
  max-w-xl sm:max-w-xl
  rounded-t-2xl sm:rounded-2xl
  shadow-[0_20px_60px_rgba(0,0,0,0.25)]
  animate-fadeIn
  max-h-[90vh]
  flex flex-col
">

<div className="overflow-y-auto px-5 py-4 space-y-3">

      {/* HEADER */}
<div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
  <h2 className="text-[16px] font-semibold text-gray-900">
  {editModal.type === "card" &&
    (editModal.isNew
      ? lang === "AR"
        ? "إضافة سلايدر"
        : "Add Slider"
      : TEXT.editCard)}

  {editModal.type === "carousel" &&
    (lang === "AR" ? "تعديل صورة التصنيف" : "Edit Category Image")}

  {editModal.type === "carouselTitle" &&
    (lang === "AR"
      ? "تعديل عنوان شريط التصنيفات"
      : "Edit Category Carousel Title")}

  {editModal.type === "categoryProductRows" && TEXT.editCategoryProductRows}
  {editModal.type === "aboutPage" && TEXT.editAboutPage}
  {editModal.type === "termsPage" && TEXT.editTermsPage}
  {editModal.type === "privacyPage" && TEXT.editPrivacyPage}
  {editModal.type === "paymentDeliveryPage" && TEXT.editPaymentDeliveryPage}
{editModal.type === "returnsPage" && TEXT.editReturnsPage}
{editModal.type === "productsPageFeatured" && TEXT.editProductsPageFeatured}
{editModal.type === "productInstagramReels" &&
  TEXT.editProductInstagramReels}
  {editModal.type === "headerOverlayImages" && TEXT.editHeaderOverlayImages}
  {editModal.type === "productLookSection" && TEXT.editProductLookSection}
</h2>

  {/* CLOSE BUTTON */}
  <button
    onClick={() => setEditModal(null)}
    className="text-gray-400 hover:text-gray-900 text-lg"
  >
    ✕
  </button>
</div>

{editModal.type === "productsPageFeatured" && (
  <>
    <label className="block text-[12px] font-medium text-gray-900 mb-1">
      {TEXT.titleEN}
    </label>
    <input
      className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
      value={editModal.data.title_en || ""}
      onChange={(e) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, title_en: e.target.value },
        }))
      }
    />

    <label className="block text-[12px] font-medium text-gray-900 mb-1">
      {TEXT.titleAR}
    </label>
    <input
      className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
      value={editModal.data.title_ar || ""}
      onChange={(e) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, title_ar: e.target.value },
        }))
      }
    />

    <div className="mt-4">
      <label className="block text-[12px] font-medium text-gray-900 mb-1">
        {lang === "AR" ? "اختيار المنتجات" : "Select Products"}
      </label>

      <input
        className="
          w-full
          px-3 py-2.5
          border border-gray-300
          rounded-lg
          text-sm
          bg-white
          focus:outline-none
          focus:ring-2
          focus:ring-black/10
          focus:border-black
          transition
          mb-3
        "
        placeholder={
          lang === "AR"
            ? "ابحث بالاسم، ID، رقم المنتج..."
            : "Search by name, ID, public ID..."
        }
        value={productsPageFeaturedSearch}
        onChange={(e) => setProductsPageFeaturedSearch(e.target.value)}
      />

      {Array.isArray(editModal.data.product_ids) &&
        editModal.data.product_ids.length > 0 && (
          <div className="mb-3">
            <div className="text-[11px] font-medium text-gray-500 mb-2">
              {TEXT.selectedProducts}
            </div>

            <div className="flex flex-wrap gap-2">
              {editModal.data.product_ids.map((id) => {
                const product = allProducts.find(
                  (p) => Number(p.id) === Number(id)
                );

                return (
                  <div
                    key={id}
                    className="
                      inline-flex items-center gap-2
                      px-2.5 py-1.5
                      rounded-full
                      bg-gray-100
                      border border-gray-200
                      text-[11px]
                      text-gray-800
                    "
                  >
                    <span className="font-semibold">#{id}</span>

                    <span className="max-w-[150px] truncate">
                      {product
                        ? lang === "AR"
                          ? product.name_ar
                          : product.name_en
                        : "Product"}
                    </span>

                    <button
                      type="button"
                      className="text-gray-400 hover:text-red-600"
                      onClick={() =>
                        setEditModal((prev) => ({
                          ...prev,
                          data: {
                            ...prev.data,
                            product_ids: prev.data.product_ids.filter(
                              (x) => Number(x) !== Number(id)
                            ),
                          },
                        }))
                      }
                    >
                      ×
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        )}

      <div className="border border-gray-200 rounded-xl overflow-hidden bg-white max-h-[320px] overflow-y-auto">
        {filteredProductsPageFeaturedProducts.length === 0 ? (
          <div className="p-4 text-center text-sm text-gray-500">
            {lang === "AR" ? "لا توجد منتجات" : "No products found"}
          </div>
        ) : (
          filteredProductsPageFeaturedProducts.map((p) => {
            const selected = (editModal.data.product_ids || []).some(
              (id) => Number(id) === Number(p.id)
            );

            const firstImage =
              p.image ||
              p.image_url ||
              (Array.isArray(p.images) ? p.images[0] : "") ||
              "/images/placeholder-product.jpg";

            return (
              <button
                key={p.id}
                type="button"
                onClick={() => {
                  setEditModal((prev) => {
                    const current = Array.isArray(prev.data.product_ids)
                      ? prev.data.product_ids
                      : [];

                    const id = Number(p.id);
                    const exists = current.some((x) => Number(x) === id);

                    return {
                      ...prev,
                      data: {
                        ...prev.data,
                        product_ids: exists
                          ? current.filter((x) => Number(x) !== id)
                          : [...current, id],
                      },
                    };
                  });
                }}
                className={`
                  w-full
                  flex items-center gap-3
                  px-3 py-2.5
                  text-left
                  border-b border-gray-100 last:border-b-0
                  transition
                  ${selected ? "bg-black/[0.04]" : "hover:bg-gray-50"}
                `}
              >
                <div className="w-12 h-12 rounded-md overflow-hidden bg-gray-100 border border-gray-200 shrink-0">
                  <ProductMediaPreview
                    src={firstImage}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="text-[11px] text-gray-400 font-medium">
                      ID: {p.id}
                    </span>

                    {p.public_id && (
                      <span className="text-[11px] text-gray-400 truncate">
                        {p.public_id}
                      </span>
                    )}
                  </div>

                  <div className="text-[13px] font-medium text-gray-900 truncate">
                    {lang === "AR" ? p.name_ar : p.name_en}
                  </div>

                  <div className="text-[11px] text-gray-500 truncate">
                    ${p.base_price || p.price || 0}
                  </div>
                </div>

                <div
                  className={`
                    w-5 h-5
                    rounded-full
                    border
                    flex items-center justify-center
                    shrink-0
                    text-[12px]
                    ${
                      selected
                        ? "bg-black border-black text-white"
                        : "bg-white border-gray-300 text-transparent"
                    }
                  `}
                >
                  ✓
                </div>
              </button>
            );
          })
        )}
      </div>
    </div>
  </>
)}

{editModal.type === "headerOverlayImages" && (
  <>
    <ImageUploadField
      label={TEXT.clothesOverlayImage}
      helper={
        lang === "AR"
          ? "الحجم المقترح: 660 × 570 px أو نفس النسبة تقريباً"
          : "Recommended size: 660 × 570 px or similar ratio"
      }
      value={editModal.data.clothes?.image_url}
      onChange={(url) =>
        setEditModal((prev) => ({
          ...prev,
          data: {
            ...prev.data,
            clothes: {
              ...(prev.data.clothes || {}),
              image_url: url,
            },
          },
        }))
      }
    />
<HeaderOverlayTargetSelect
  label={TEXT.clothesOverlayTarget}
  value={editModal.data.clothes?.link_target}
  onChange={(target) =>
    setEditModal((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        clothes: {
          ...(prev.data.clothes || {}),
          link_target: target,
        },
      },
    }))
  }
/>
    <ImageUploadField
      label={TEXT.shoesOverlayImage}
      helper={
        lang === "AR"
          ? "الحجم المقترح: 660 × 570 px أو نفس النسبة تقريباً"
          : "Recommended size: 660 × 570 px or similar ratio"
      }
      value={editModal.data.shoes?.image_url}
      onChange={(url) =>
        setEditModal((prev) => ({
          ...prev,
          data: {
            ...prev.data,
            shoes: {
              ...(prev.data.shoes || {}),
              image_url: url,
            },
          },
        }))
      }
    />
<HeaderOverlayTargetSelect
  label={TEXT.shoesOverlayTarget}
  value={editModal.data.shoes?.link_target}
  onChange={(target) =>
    setEditModal((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        shoes: {
          ...(prev.data.shoes || {}),
          link_target: target,
        },
      },
    }))
  }
/>
    <ImageUploadField
      label={TEXT.accessoriesOverlayImage}
      helper={
        lang === "AR"
          ? "الحجم المقترح: 660 × 570 px أو نفس النسبة تقريباً"
          : "Recommended size: 660 × 570 px or similar ratio"
      }
      value={editModal.data.accessories?.image_url}
      onChange={(url) =>
        setEditModal((prev) => ({
          ...prev,
          data: {
            ...prev.data,
            accessories: {
              ...(prev.data.accessories || {}),
              image_url: url,
            },
          },
        }))
      }
    />
    <HeaderOverlayTargetSelect
  label={TEXT.accessoriesOverlayTarget}
  value={editModal.data.accessories?.link_target}
  onChange={(target) =>
    setEditModal((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        accessories: {
          ...(prev.data.accessories || {}),
          link_target: target,
        },
      },
    }))
  }
/>
  </>
)}

{editModal.type === "productLookSection" && (
  <>
    <ModalInput
      label={TEXT.titleEN}
      value={editModal.data.title_en}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, title_en: value },
        }))
      }
    />

    <ModalInput
      label={TEXT.titleAR}
      value={editModal.data.title_ar}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, title_ar: value },
        }))
      }
    />

    <div className="mt-2 rounded-lg border border-blue-100 bg-blue-50 px-3 py-2 text-[12px] leading-5 text-blue-800">
      {lang === "AR"
        ? "ملاحظة: منتجات هذا القسم تظهر تلقائياً حسب تصنيف ووسوم المنتج الحالي. يمكنك تعديل العنوان فقط من هنا."
        : "Note: products in this section are generated automatically from the current product category and tags. You can edit only the section title here."}
    </div>
  </>
)}

{editModal.type === "productInstagramReels" && (
  <>
    <ModalInput
      label={TEXT.instagramReelsTitleEN}
      value={editModal.data.title_en}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, title_en: value },
        }))
      }
    />

    <ModalInput
      label={TEXT.instagramReelsTitleAR}
      value={editModal.data.title_ar}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, title_ar: value },
        }))
      }
    />

    <div className="pt-4 mt-4 border-t border-gray-200">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-gray-900">
          {TEXT.productInstagramReels}
        </h3>

        <button
          type="button"
          className="px-3 py-1.5 rounded-md bg-black text-white text-xs font-medium hover:bg-gray-800"
          onClick={() =>
            setEditModal((prev) => ({
              ...prev,
              data: {
                ...prev.data,
                reels: [
                  ...(Array.isArray(prev.data.reels)
                    ? prev.data.reels
                    : []),
                  {
                    video_url: "",
                    reel_url: "",
                    likes: "",
                  },
                ],
              },
            }))
          }
        >
          {TEXT.addInstagramReel}
        </button>
      </div>

      <div className="space-y-3">
        {(editModal.data.reels || []).map((reel, index) => (
          <div
            key={index}
            className="border border-gray-200 rounded-xl p-3 bg-gray-50"
          >
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs font-semibold text-gray-700">
                Reel #{index + 1}
              </span>

              <button
                type="button"
                className="text-xs font-medium text-red-600 hover:underline"
                onClick={() =>
                  setEditModal((prev) => ({
                    ...prev,
                    data: {
                      ...prev.data,
                      reels: prev.data.reels.filter((_, i) => i !== index),
                    },
                  }))
                }
              >
                {TEXT.delete}
              </button>
            </div>

            {/* VIDEO UPLOAD */}
            <div className="mb-3">
              <label className="block text-[12px] font-medium text-gray-900 mb-1">
                {lang === "AR" ? "فيديو الريل" : "Reel Video"}
              </label>

              <input
                id={`instagram-reel-video-${index}`}
                type="file"
                accept="video/*"
                className="hidden"
                onChange={async (e) => {
                  const file = e.target.files?.[0];
                  if (!file) return;

                  setUploading(true);

                  try {
                    const uploaded = await uploadAdminFile(file);

                    setEditModal((prev) => ({
                      ...prev,
                      data: {
                        ...prev.data,
                        reels: prev.data.reels.map((item, i) =>
                          i === index
                            ? {
                                ...item,
                                video_url: uploaded.url,
                              }
                            : item
                        ),
                      },
                    }));
                  } catch (err) {
                    alert(err.message || TEXT.uploadFailed);
                  } finally {
                    setUploading(false);
                    e.target.value = "";
                  }
                }}
              />

              <label
                htmlFor={`instagram-reel-video-${index}`}
                className="
                  inline-flex items-center gap-2
                  px-3 py-1.5
                  rounded-md
                  border border-gray-300
                  bg-white
                  text-gray-900
                  text-[12px] font-medium
                  hover:bg-gray-100
                  active:scale-[0.98]
                  transition
                  cursor-pointer
                "
              >
                <FaUpload className="text-[12px]" />
                {uploading
                  ? TEXT.uploading
                  : lang === "AR"
                  ? "رفع الفيديو"
                  : "Upload video"}
              </label>

              {reel.video_url && (
                <div className="mt-3 w-[120px] aspect-[9/16] bg-black rounded-md overflow-hidden border">
                  <video
                    src={resolveImage(reel.video_url)}
                    muted
                    playsInline
                    preload="metadata"
                    className="w-full h-full object-cover"
                  />
                </div>
              )}
            </div>

            {/* INSTAGRAM LINK */}
            <ModalInput
              label={TEXT.instagramReelUrl}
              value={reel.reel_url || reel.url || ""}
              onChange={(value) =>
                setEditModal((prev) => ({
                  ...prev,
                  data: {
                    ...prev.data,
                    reels: prev.data.reels.map((item, i) =>
                      i === index ? { ...item, reel_url: value } : item
                    ),
                  },
                }))
              }
            />

            {/* LIKES */}
            <ModalInput
              label={TEXT.instagramReelLikes}
              value={reel.likes}
              onChange={(value) =>
                setEditModal((prev) => ({
                  ...prev,
                  data: {
                    ...prev.data,
                    reels: prev.data.reels.map((item, i) =>
                      i === index ? { ...item, likes: value } : item
                    ),
                  },
                }))
              }
            />
          </div>
        ))}
      </div>
    </div>
  </>
)}

{editModal.type === "searchOverlay" && (
  <>
    <label className="block text-[12px] font-medium text-gray-900 mb-1">
      {TEXT.popularSearchTerms}
    </label>

    <textarea
      rows={4}
      className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3 resize-y"
      value={(editModal.data.popular_terms || []).join("\n")}
      onChange={(e) =>
        setEditModal((prev) => ({
          ...prev,
          data: {
            ...prev.data,
            popular_terms: e.target.value
              .split("\n")
              .map((x) => x.trim())
              .filter(Boolean),
          },
        }))
      }
      placeholder="dress&#10;red&#10;new collection"
    />

    <div className="mt-4">
      <label className="block text-[12px] font-medium text-gray-900 mb-1">
        {TEXT.recommendedSearchProducts}
      </label>

      <input
        className="
          w-full
          px-3 py-2.5
          border border-gray-300
          rounded-lg
          text-sm
          bg-white
          focus:outline-none
          focus:ring-2
          focus:ring-black/10
          focus:border-black
          transition
          mb-3
        "
        placeholder={
          lang === "AR"
            ? "ابحث بالاسم، ID، رقم المنتج..."
            : "Search by name, ID, public ID..."
        }
        value={searchRecommendedProductSearch}
        onChange={(e) => setSearchRecommendedProductSearch(e.target.value)}
      />

      {Array.isArray(editModal.data.product_ids) &&
        editModal.data.product_ids.length > 0 && (
          <div className="mb-3">
            <div className="text-[11px] font-medium text-gray-500 mb-2">
              {TEXT.selectedProducts}
            </div>

            <div className="flex flex-wrap gap-2">
              {editModal.data.product_ids.map((id) => {
                const product = allProducts.find(
                  (p) => Number(p.id) === Number(id)
                );

                return (
                  <div
                    key={id}
                    className="
                      inline-flex items-center gap-2
                      px-2.5 py-1.5
                      rounded-full
                      bg-gray-100
                      border border-gray-200
                      text-[11px]
                      text-gray-800
                    "
                  >
                    <span className="font-semibold">#{id}</span>

                    <span className="max-w-[150px] truncate">
                      {product
                        ? lang === "AR"
                          ? product.name_ar
                          : product.name_en
                        : "Product"}
                    </span>

                    <button
                      type="button"
                      className="text-gray-400 hover:text-red-600"
                      onClick={() =>
                        setEditModal((prev) => ({
                          ...prev,
                          data: {
                            ...prev.data,
                            product_ids: prev.data.product_ids.filter(
                              (x) => Number(x) !== Number(id)
                            ),
                          },
                        }))
                      }
                    >
                      ×
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        )}

      <div className="border border-gray-200 rounded-xl overflow-hidden bg-white max-h-[320px] overflow-y-auto">
        {allProducts
          .filter((p) => p.status !== "archived")
          .filter((p) => {
            const q = searchRecommendedProductSearch.trim().toLowerCase();
            if (!q) return true;

            return (
              String(p.id || "").includes(q) ||
              String(p.public_id || "").toLowerCase().includes(q) ||
              String(p.name_en || "").toLowerCase().includes(q) ||
              String(p.name_ar || "").toLowerCase().includes(q) ||
              String(p.seo_slug || "").toLowerCase().includes(q)
            );
          })
          .slice(0, 80)
          .map((p) => {
            const selected = (editModal.data.product_ids || []).some(
              (id) => Number(id) === Number(p.id)
            );

            const firstImage =
              p.image ||
              p.image_url ||
              (Array.isArray(p.images) ? p.images[0] : "") ||
              "/images/placeholder-product.jpg";

            return (
              <button
                key={p.id}
                type="button"
                onClick={() => {
                  setEditModal((prev) => {
                    const current = Array.isArray(prev.data.product_ids)
                      ? prev.data.product_ids
                      : [];

                    const id = Number(p.id);
                    const exists = current.some((x) => Number(x) === id);

                    return {
                      ...prev,
                      data: {
                        ...prev.data,
                        product_ids: exists
                          ? current.filter((x) => Number(x) !== id)
                          : [...current, id],
                      },
                    };
                  });
                }}
                className={`
                  w-full
                  flex items-center gap-3
                  px-3 py-2.5
                  text-left
                  border-b border-gray-100 last:border-b-0
                  transition
                  ${selected ? "bg-black/[0.04]" : "hover:bg-gray-50"}
                `}
              >
                <div className="w-12 h-12 rounded-md overflow-hidden bg-gray-100 border border-gray-200 shrink-0">
                  <ProductMediaPreview
                    src={firstImage}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="min-w-0 flex-1">
                  <div className="text-[11px] text-gray-400 font-medium">
                    ID: {p.id}
                  </div>

                  <div className="text-[13px] font-medium text-gray-900 truncate">
                    {lang === "AR" ? p.name_ar : p.name_en}
                  </div>

                  <div className="text-[11px] text-gray-500 truncate">
                    ${p.base_price || p.price || 0}
                  </div>
                </div>

                <div
                  className={`
                    w-5 h-5
                    rounded-full
                    border
                    flex items-center justify-center
                    shrink-0
                    text-[12px]
                    ${
                      selected
                        ? "bg-black border-black text-white"
                        : "bg-white border-gray-300 text-transparent"
                    }
                  `}
                >
                  ✓
                </div>
              </button>
            );
          })}
      </div>
    </div>
  </>
)}

{editModal.type === "carouselTitle" && (
  <>
    <label className="block text-[12px] font-medium text-gray-900 mb-1">
      {TEXT.titleEN}
    </label>
    <input
      className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
      value={editModal.data.title_en || ""}
      onChange={(e) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, title_en: e.target.value },
        }))
      }
    />

    <label className="block text-[12px] font-medium text-gray-900 mb-1">
      {TEXT.titleAR}
    </label>
    <input
      className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
      value={editModal.data.title_ar || ""}
      onChange={(e) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, title_ar: e.target.value },
        }))
      }
    />
  </>
)}

{editModal.type === "carousel" && (
  <>
    <div className="mb-3 text-sm text-gray-600">
      <div><b>Name:</b> {editModal.data.name_en}</div>
      <div><b>Slug:</b> {editModal.data.slug}</div>
    </div>

    <ImageUploadField
  label={TEXT.carouselImage}
  helper={
    lang === "AR"
      ? "الحجم المقترح: صورة مربعة 800 × 800 px لتظهر بشكل مثالي داخل الدائرة على الموبايل والكمبيوتر"
      : "Recommended size: square image 800 × 800 px for perfect circle display on mobile and desktop"
  }
  value={editModal.data.image_url}
  onChange={(url) =>
    setEditModal((prev) => ({
      ...prev,
      data: { ...prev.data, image_url: url },
    }))
  }
/>

  </>
)}


{editModal.type === "categoryProductRows" && (
  <>
    <div className="flex items-center justify-between mb-3">
      <p className="text-sm font-semibold text-gray-900">
        {TEXT.categoryProductRows}
      </p>

      <button
        type="button"
        className="px-3 py-1.5 rounded-md bg-black text-white text-xs font-medium hover:bg-gray-800"
        onClick={() =>
          setEditModal((prev) => ({
            ...prev,
            data: {
              ...prev.data,
              rows: [
                ...(Array.isArray(prev.data.rows) ? prev.data.rows : []),
                {
                  category_id: "",
                  sort_order: (prev.data.rows || []).length + 1,
                  product_ids: [],
                },
              ],
            },
          }))
        }
      >
        {TEXT.addCategoryRow}
      </button>
    </div>

    <div className="space-y-4">
      {(editModal.data.rows || []).map((row, rowIndex) => {
        const selectedIds = Array.isArray(row.product_ids)
          ? row.product_ids.map(Number)
          : [];

        const selectedCollection = categories.find(
  (c) => Number(c.id) === Number(row.category_id)
);

const filteredProducts = allProducts
  .filter((p) => p.status !== "archived")
  .filter((p) =>
    selectedCollection
      ? productBelongsToCollection(p, selectedCollection)
      : false
  )
  .filter((p) => {
    const q = categoryRowProductSearch.trim().toLowerCase();
    if (!q) return true;

    return (
      String(p.id || "").includes(q) ||
      String(p.public_id || "").toLowerCase().includes(q) ||
      String(p.name_en || "").toLowerCase().includes(q) ||
      String(p.name_ar || "").toLowerCase().includes(q) ||
      String(p.seo_slug || "").toLowerCase().includes(q)
    );
  })
  .slice(0, 80);

        return (
          <div
            key={rowIndex}
            className="border border-gray-200 rounded-xl p-3 bg-gray-50"
          >
            <div className="flex items-center justify-between mb-3">
              <span className="text-xs font-semibold text-gray-700">
                {lang === "AR" ? "صف مجموعة" : "Collection Row"} #{rowIndex + 1}
              </span>

              <div className="flex items-center gap-2">
                <button
                  type="button"
                  disabled={rowIndex === 0}
                  className="text-xs px-2 py-1 rounded border bg-white disabled:opacity-40"
                  onClick={() =>
                    setEditModal((prev) => {
                      const rows = [...prev.data.rows];
                      const temp = rows[rowIndex - 1];
                      rows[rowIndex - 1] = rows[rowIndex];
                      rows[rowIndex] = temp;

                      return {
                        ...prev,
                        data: {
                          ...prev.data,
                          rows: rows.map((item, i) => ({
                            ...item,
                            sort_order: i + 1,
                          })),
                        },
                      };
                    })
                  }
                >
                  ↑
                </button>

                <button
                  type="button"
                  disabled={rowIndex === editModal.data.rows.length - 1}
                  className="text-xs px-2 py-1 rounded border bg-white disabled:opacity-40"
                  onClick={() =>
                    setEditModal((prev) => {
                      const rows = [...prev.data.rows];
                      const temp = rows[rowIndex + 1];
                      rows[rowIndex + 1] = rows[rowIndex];
                      rows[rowIndex] = temp;

                      return {
                        ...prev,
                        data: {
                          ...prev.data,
                          rows: rows.map((item, i) => ({
                            ...item,
                            sort_order: i + 1,
                          })),
                        },
                      };
                    })
                  }
                >
                  ↓
                </button>

                <button
                  type="button"
                  className="text-xs font-medium text-red-600 hover:underline"
                  onClick={() =>
                    setEditModal((prev) => ({
                      ...prev,
                      data: {
                        ...prev.data,
                        rows: prev.data.rows.filter((_, i) => i !== rowIndex),
                      },
                    }))
                  }
                >
                  {TEXT.delete}
                </button>
              </div>
            </div>

            <label className="block text-[12px] font-medium text-gray-900 mb-1">
              {TEXT.category}
            </label>

            <select
              className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3 bg-white"
              value={row.category_id || ""}
              onChange={(e) =>
  setEditModal((prev) => ({
    ...prev,
    data: {
      ...prev.data,
      rows: prev.data.rows.map((item, i) =>
        i === rowIndex
          ? {
              ...item,
              category_id: Number(e.target.value),
              product_ids: [],
            }
          : item
      ),
    },
  }))
}
            >
              <option value="">
                {lang === "AR" ? "اختر مجموعة" : "Select collection"}
              </option>

              {categories.map((c) => (
                <option key={c.id} value={c.id}>
                  {lang === "AR" ? c.name_ar : c.name_en} ({c.slug})
                </option>
              ))}
            </select>

            <input
              className="
                w-full
                px-3 py-2.5
                border border-gray-300
                rounded-lg
                text-sm
                bg-white
                focus:outline-none
                focus:ring-2
                focus:ring-black/10
                focus:border-black
                transition
                mb-3
              "
              placeholder={
                lang === "AR"
                  ? "ابحث بالاسم، ID، رقم المنتج..."
                  : "Search by name, ID, public ID..."
              }
              value={categoryRowProductSearch}
              onChange={(e) => setCategoryRowProductSearch(e.target.value)}
            />

            {selectedIds.length > 0 && (
              <div className="mb-3">
                <div className="text-[11px] font-medium text-gray-500 mb-2">
                  {TEXT.selectedProducts}
                </div>

                <div className="flex flex-wrap gap-2">
                  {selectedIds.map((id) => {
                    const product = allProducts.find(
                      (p) => Number(p.id) === Number(id)
                    );

                    return (
                      <div
                        key={id}
                        className="
                          inline-flex items-center gap-2
                          px-2.5 py-1.5
                          rounded-full
                          bg-white
                          border border-gray-200
                          text-[11px]
                          text-gray-800
                        "
                      >
                        <span className="font-semibold">#{id}</span>

                        <span className="max-w-[150px] truncate">
                          {product
                            ? lang === "AR"
                              ? product.name_ar
                              : product.name_en
                            : "Product"}
                        </span>

                        <button
                          type="button"
                          className="text-gray-400 hover:text-red-600"
                          onClick={() =>
                            setEditModal((prev) => ({
                              ...prev,
                              data: {
                                ...prev.data,
                                rows: prev.data.rows.map((item, i) =>
                                  i === rowIndex
                                    ? {
                                        ...item,
                                        product_ids: item.product_ids.filter(
                                          (x) => Number(x) !== Number(id)
                                        ),
                                      }
                                    : item
                                ),
                              },
                            }))
                          }
                        >
                          ×
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            <div className="border border-gray-200 rounded-xl overflow-hidden bg-white max-h-[260px] overflow-y-auto">
              {filteredProducts.length === 0 ? (
  <div className="p-4 text-center text-sm text-gray-500">
    {!selectedCollection
      ? lang === "AR"
        ? "اختر مجموعة أولاً لعرض منتجاتها"
        : "Select a collection first to show its products"
      : lang === "AR"
      ? "لا توجد منتجات في هذه المجموعة"
      : "No products found in this collection"}
  </div>
) : (
                filteredProducts.map((p) => {
                  const selected = selectedIds.some(
                    (id) => Number(id) === Number(p.id)
                  );

                  const firstImage =
                    p.image ||
                    p.image_url ||
                    (Array.isArray(p.images) ? p.images[0] : "") ||
                    "/images/placeholder-product.jpg";

                  return (
                    <button
                      key={p.id}
                      type="button"
                      onClick={() => {
                        setEditModal((prev) => ({
                          ...prev,
                          data: {
                            ...prev.data,
                            rows: prev.data.rows.map((item, i) => {
                              if (i !== rowIndex) return item;

                              const current = Array.isArray(item.product_ids)
                                ? item.product_ids
                                : [];

                              const id = Number(p.id);
                              const exists = current.some(
                                (x) => Number(x) === id
                              );

                              return {
                                ...item,
                                product_ids: exists
                                  ? current.filter((x) => Number(x) !== id)
                                  : [...current, id],
                              };
                            }),
                          },
                        }));
                      }}
                      className={`
                        w-full
                        flex items-center gap-3
                        px-3 py-2.5
                        text-left
                        border-b border-gray-100 last:border-b-0
                        transition
                        ${selected ? "bg-black/[0.04]" : "hover:bg-gray-50"}
                      `}
                    >
                      <div className="w-12 h-12 rounded-md overflow-hidden bg-gray-100 border border-gray-200 shrink-0">
                        <ProductMediaPreview
                          src={firstImage}
                          className="w-full h-full object-cover"
                        />
                      </div>

                      <div className="min-w-0 flex-1">
                        <div className="flex items-center gap-2">
                          <span className="text-[11px] text-gray-400 font-medium">
                            ID: {p.id}
                          </span>

                          {p.public_id && (
                            <span className="text-[11px] text-gray-400 truncate">
                              {p.public_id}
                            </span>
                          )}
                        </div>

                        <div className="text-[13px] font-medium text-gray-900 truncate">
                          {lang === "AR" ? p.name_ar : p.name_en}
                        </div>

                        <div className="text-[11px] text-gray-500 truncate">
                          ${p.base_price || p.price || 0}
                        </div>
                      </div>

                      <div
                        className={`
                          w-5 h-5
                          rounded-full
                          border
                          flex items-center justify-center
                          shrink-0
                          text-[12px]
                          ${
                            selected
                              ? "bg-black border-black text-white"
                              : "bg-white border-gray-300 text-transparent"
                          }
                        `}
                      >
                        ✓
                      </div>
                    </button>
                  );
                })
              )}
            </div>
          </div>
        );
      })}
    </div>
  </>
)}

{editModal.type === "aboutPage" && (
  <>
    <ImageUploadField
      label={TEXT.aboutImageOne}
      helper={
        lang === "AR"
          ? "الحجم المقترح: 1200 × 900 px"
          : "Recommended size: 1200 × 900 px"
      }
      value={editModal.data.image_1}
      onChange={(url) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, image_1: url },
        }))
      }
    />

    <ImageUploadField
      label={TEXT.aboutImageTwo}
      helper={
        lang === "AR"
          ? "الحجم المقترح: 1200 × 900 px"
          : "Recommended size: 1200 × 900 px"
      }
      value={editModal.data.image_2}
      onChange={(url) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, image_2: url },
        }))
      }
    />

    <ImageUploadField
      label={TEXT.aboutImageThree}
      helper={
        lang === "AR"
          ? "الحجم المقترح: 1200 × 900 px"
          : "Recommended size: 1200 × 900 px"
      }
      value={editModal.data.image_3}
      onChange={(url) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, image_3: url },
        }))
      }
    />

<div className="pt-4 border-t border-gray-200">
  <h3 className="text-sm font-semibold text-gray-900 mb-3">
    {TEXT.aboutTextContent}
  </h3>

  <ModalInput
    label={TEXT.hiEN}
    value={editModal.data.hi_en}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, hi_en: value },
      }))
    }
  />

  <ModalInput
    label={TEXT.hiAR}
    value={editModal.data.hi_ar}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, hi_ar: value },
      }))
    }
  />

  <ModalTextarea
    label={TEXT.paragraphOneEN}
    value={editModal.data.paragraph_1_en}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, paragraph_1_en: value },
      }))
    }
  />

  <ModalTextarea
    label={TEXT.paragraphOneAR}
    value={editModal.data.paragraph_1_ar}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, paragraph_1_ar: value },
      }))
    }
  />

  <ModalTextarea
    label={TEXT.paragraphTwoEN}
    value={editModal.data.paragraph_2_en}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, paragraph_2_en: value },
      }))
    }
  />

  <ModalTextarea
    label={TEXT.paragraphTwoAR}
    value={editModal.data.paragraph_2_ar}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, paragraph_2_ar: value },
      }))
    }
  />

  <ModalInput
    label={TEXT.stylingTitleEN}
    value={editModal.data.styling_title_en}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, styling_title_en: value },
      }))
    }
  />

  <ModalInput
    label={TEXT.stylingTitleAR}
    value={editModal.data.styling_title_ar}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, styling_title_ar: value },
      }))
    }
  />

  <ModalInput
    label={TEXT.bulletOneEN}
    value={editModal.data.bullet_1_en}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, bullet_1_en: value },
      }))
    }
  />

  <ModalInput
    label={TEXT.bulletOneAR}
    value={editModal.data.bullet_1_ar}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, bullet_1_ar: value },
      }))
    }
  />

  <ModalInput
    label={TEXT.bulletTwoEN}
    value={editModal.data.bullet_2_en}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, bullet_2_en: value },
      }))
    }
  />

  <ModalInput
    label={TEXT.bulletTwoAR}
    value={editModal.data.bullet_2_ar}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, bullet_2_ar: value },
      }))
    }
  />

  <ModalInput
    label={TEXT.bulletThreeEN}
    value={editModal.data.bullet_3_en}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, bullet_3_en: value },
      }))
    }
  />

  <ModalInput
    label={TEXT.bulletThreeAR}
    value={editModal.data.bullet_3_ar}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, bullet_3_ar: value },
      }))
    }
  />

  <ModalTextarea
    label={TEXT.founderTextEN}
    value={editModal.data.founder_text_en}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, founder_text_en: value },
      }))
    }
  />

  <ModalTextarea
    label={TEXT.founderTextAR}
    value={editModal.data.founder_text_ar}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, founder_text_ar: value },
      }))
    }
  />

  <ModalInput
    label={TEXT.mottoPrefixEN}
    value={editModal.data.motto_prefix_en}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, motto_prefix_en: value },
      }))
    }
  />

  <ModalInput
    label={TEXT.mottoPrefixAR}
    value={editModal.data.motto_prefix_ar}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, motto_prefix_ar: value },
      }))
    }
  />

  <ModalInput
    label={TEXT.mottoTextEN}
    value={editModal.data.motto_text_en}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, motto_text_en: value },
      }))
    }
  />

  <ModalInput
    label={TEXT.mottoTextAR}
    value={editModal.data.motto_text_ar}
    onChange={(value) =>
      setEditModal((prev) => ({
        ...prev,
        data: { ...prev.data, motto_text_ar: value },
      }))
    }
  />
</div>

    <div className="pt-4 border-t border-gray-200">
      <h3 className="text-sm font-semibold text-gray-900 mb-3">
        {TEXT.newProductsCounter}
      </h3>

      <label className="block text-[12px] font-medium text-gray-900 mb-1">
        {TEXT.counterValue}
      </label>
      <input
        className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
        value={editModal.data.new_products_value || ""}
        onChange={(e) =>
          setEditModal((prev) => ({
            ...prev,
            data: { ...prev.data, new_products_value: e.target.value },
          }))
        }
      />

      <label className="block text-[12px] font-medium text-gray-900 mb-1">
        {TEXT.counterLabelEN}
      </label>
      <input
        className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
        value={editModal.data.new_products_label_en || ""}
        onChange={(e) =>
          setEditModal((prev) => ({
            ...prev,
            data: { ...prev.data, new_products_label_en: e.target.value },
          }))
        }
      />

      <label className="block text-[12px] font-medium text-gray-900 mb-1">
        {TEXT.counterLabelAR}
      </label>
      <input
        className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
        value={editModal.data.new_products_label_ar || ""}
        onChange={(e) =>
          setEditModal((prev) => ({
            ...prev,
            data: { ...prev.data, new_products_label_ar: e.target.value },
          }))
        }
      />
    </div>

    <div className="pt-4 border-t border-gray-200">
      <h3 className="text-sm font-semibold text-gray-900 mb-3">
        {TEXT.completionTimeCounter}
      </h3>

      <label className="block text-[12px] font-medium text-gray-900 mb-1">
        {TEXT.counterValue}
      </label>
      <input
        className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
        value={editModal.data.completion_time_value || ""}
        onChange={(e) =>
          setEditModal((prev) => ({
            ...prev,
            data: { ...prev.data, completion_time_value: e.target.value },
          }))
        }
      />

      <label className="block text-[12px] font-medium text-gray-900 mb-1">
        {TEXT.counterLabelEN}
      </label>
      <input
        className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
        value={editModal.data.completion_time_label_en || ""}
        onChange={(e) =>
          setEditModal((prev) => ({
            ...prev,
            data: { ...prev.data, completion_time_label_en: e.target.value },
          }))
        }
      />

      <label className="block text-[12px] font-medium text-gray-900 mb-1">
        {TEXT.counterLabelAR}
      </label>
      <input
        className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
        value={editModal.data.completion_time_label_ar || ""}
        onChange={(e) =>
          setEditModal((prev) => ({
            ...prev,
            data: { ...prev.data, completion_time_label_ar: e.target.value },
          }))
        }
      />
    </div>

    <div className="pt-4 border-t border-gray-200">
      <h3 className="text-sm font-semibold text-gray-900 mb-3">
        {TEXT.marketCounter}
      </h3>

      <label className="block text-[12px] font-medium text-gray-900 mb-1">
        {TEXT.counterValue}
      </label>
      <input
        className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
        value={editModal.data.market_value || ""}
        onChange={(e) =>
          setEditModal((prev) => ({
            ...prev,
            data: { ...prev.data, market_value: e.target.value },
          }))
        }
      />

      <label className="block text-[12px] font-medium text-gray-900 mb-1">
        {TEXT.counterLabelEN}
      </label>
      <input
        className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
        value={editModal.data.market_label_en || ""}
        onChange={(e) =>
          setEditModal((prev) => ({
            ...prev,
            data: { ...prev.data, market_label_en: e.target.value },
          }))
        }
      />

      <label className="block text-[12px] font-medium text-gray-900 mb-1">
        {TEXT.counterLabelAR}
      </label>
      <input
        className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
        value={editModal.data.market_label_ar || ""}
        onChange={(e) =>
          setEditModal((prev) => ({
            ...prev,
            data: { ...prev.data, market_label_ar: e.target.value },
          }))
        }
      />
    </div>
  </>
)}

{editModal.type === "termsPage" && (
  <>
    <ModalInput
      label={TEXT.titleEN}
      value={editModal.data.title_en}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, title_en: value },
        }))
      }
    />

    <ModalInput
      label={TEXT.titleAR}
      value={editModal.data.title_ar}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, title_ar: value },
        }))
      }
    />

    <ModalTextarea
  rows={10}
  label={TEXT.termsContentEN}
  value={editModal.data.content_en}
  onChange={(value) =>
    setEditModal((prev) => ({
      ...prev,
      data: { ...prev.data, content_en: value },
    }))
  }
/>

<ModalTextarea
  rows={10}
  label={TEXT.termsContentAR}
  value={editModal.data.content_ar}
  onChange={(value) =>
    setEditModal((prev) => ({
      ...prev,
      data: { ...prev.data, content_ar: value },
    }))
  }
/>
  </>
)}

{editModal.type === "privacyPage" && (
  <>
    <ModalInput
      label={TEXT.titleEN}
      value={editModal.data.title_en}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, title_en: value },
        }))
      }
    />

    <ModalInput
      label={TEXT.titleAR}
      value={editModal.data.title_ar}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, title_ar: value },
        }))
      }
    />

    <ModalTextarea
      rows={10}
      label={TEXT.privacyContentEN}
      value={editModal.data.content_en}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, content_en: value },
        }))
      }
    />

    <ModalTextarea
      rows={10}
      label={TEXT.privacyContentAR}
      value={editModal.data.content_ar}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, content_ar: value },
        }))
      }
    />
  </>
)}

{editModal.type === "paymentDeliveryPage" && (
  <>
    <ModalInput
      label={TEXT.titleEN}
      value={editModal.data.title_en}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, title_en: value },
        }))
      }
    />

    <ModalInput
      label={TEXT.titleAR}
      value={editModal.data.title_ar}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, title_ar: value },
        }))
      }
    />

    <ModalTextarea
      rows={10}
      label={TEXT.paymentDeliveryContentEN}
      value={editModal.data.content_en}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, content_en: value },
        }))
      }
    />

    <ModalTextarea
      rows={10}
      label={TEXT.paymentDeliveryContentAR}
      value={editModal.data.content_ar}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, content_ar: value },
        }))
      }
    />
  </>
)}

{editModal.type === "returnsPage" && (
  <>
    <ModalInput
      label={TEXT.titleEN}
      value={editModal.data.title_en}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, title_en: value },
        }))
      }
    />

    <ModalInput
      label={TEXT.titleAR}
      value={editModal.data.title_ar}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, title_ar: value },
        }))
      }
    />

    <ModalTextarea
      rows={10}
      label={TEXT.returnsContentEN}
      value={editModal.data.content_en}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, content_en: value },
        }))
      }
    />

    <ModalTextarea
      rows={10}
      label={TEXT.returnsContentAR}
      value={editModal.data.content_ar}
      onChange={(value) =>
        setEditModal((prev) => ({
          ...prev,
          data: { ...prev.data, content_ar: value },
        }))
      }
    />
  </>
)}


  {editModal.type !== "card" &&
 editModal.type !== "carousel" &&
 editModal.type !== "carouselTitle" &&
 editModal.type !== "productsPageFeatured" &&
 editModal.type !== "aboutPage" &&
 editModal.type !== "termsPage" &&
editModal.type !== "privacyPage" &&
editModal.type !== "paymentDeliveryPage" &&
editModal.type !== "returnsPage" && 
editModal.type !== "productInstagramReels" &&
editModal.type !== "productLookSection" &&
editModal.type !== "categoryProductRows" &&
editModal.type !== "headerOverlayImages" &&(
  <>
    {/* TITLE EN */}
    <label className="block text-[12px] font-medium text-gray-600 text-gray-900 mb-1">
      {TEXT.titleEN}
    </label>
    <input
      className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
      placeholder={TEXT.titleEN}
      value={editModal.data.title_en}
      onChange={(e) =>
        setEditModal({
          ...editModal,
          data: { ...editModal.data, title_en: e.target.value },
        })
      }
    />

    {/* TITLE AR */}
    <label className="block text-[12px] font-medium text-gray-600 text-gray-900 mb-1">
      {TEXT.titleAR}
    </label>
    <input
      className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
      placeholder={TEXT.titleAR}
      value={editModal.data.title_ar}
      onChange={(e) =>
        setEditModal({
          ...editModal,
          data: { ...editModal.data, title_ar: e.target.value },
        })
      }
    />
  </>
)}

      {/* ================= CATEGORY CARD ================= */}
      {editModal.type === "card" && (
        <>
        
<ImageUploadField
  label={lang === "AR" ? "صورة الموبايل" : "Mobile Image"}
  helper={
    lang === "AR"
      ? "الحجم المطلوب: Mobile poster image: 1024 × 1280 px"
      : "Required size: Mobile poster image: 1024 × 1280 px"
  }
  value={editModal.data.mobile_image}
  onChange={(url) =>
    setEditModal((prev) => ({
      ...prev,
      data: { ...prev.data, mobile_image: url },
    }))
  }
/>
<ImageUploadField
  label={lang === "AR" ? "صورة الكومبيوتر" : "Desktop Image"}
  helper={
    lang === "AR"
      ? "الحجم المطلوب: Desktop wide image: 1920 × 750 px"
      : "Required size: Desktop wide image: 1920 × 750 px"
  }
  value={editModal.data.desktop_image}
  onChange={(url) =>
    setEditModal((prev) => ({
      ...prev,
      data: { ...prev.data, desktop_image: url },
    }))
  }
/>

<label className="block text-[12px] font-medium text-gray-600 text-gray-900 mb-1">
  {lang === "AR" ? "رابط السلايدر" : "Slider Target"}
</label>

<select
  className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
  value={editModal.data.key || ""}
  onChange={(e) =>
    setEditModal((prev) => ({
      ...prev,
      data: { ...prev.data, key: e.target.value },
    }))
  }
>
  <option value="">
    {lang === "AR" ? "اختر الهدف" : "Select target"}
  </option>

  {categoryCardTargetOptions.map((item) => (
    <option key={item.key} value={item.key}>
      {lang === "AR" ? item.labelAR : item.labelEN} ({item.key})
    </option>
  ))}
</select>

        </>
      )}

      {editModal?.type === "categoryHero" && (
  <>
    <label className="block text-[12px] font-medium text-gray-600 text-gray-900 mb-1">
  {TEXT.subtitleEN}
</label>
<input
  className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
  placeholder={TEXT.subtitleEN}
      value={editModal.data.subtitle_en}
      onChange={(e) =>
        setEditModal({
          ...editModal,
          data: { ...editModal.data, subtitle_en: e.target.value },
        })
      }
    />

    <label className="block text-[12px] font-medium text-gray-600 text-gray-900 mb-1">
  {TEXT.subtitleAR}
</label>
<input
  className="w-full p-3 border border-gray-300 rounded-md text-sm mb-3"
  placeholder={TEXT.subtitleAR}
      value={editModal.data.subtitle_ar}
      onChange={(e) =>
        setEditModal({
          ...editModal,
          data: { ...editModal.data, subtitle_ar: e.target.value },
        })
      }
    />

    
<ImageUploadField
  label={TEXT.heroImage}
  value={editModal.data.image_url}
  onChange={(url) =>
    setEditModal((prev) => ({
      ...prev,
      data: { ...prev.data, image_url: url },
    }))
  }
/>


    <label className="block text-[12px] font-medium text-gray-600 text-gray-900 mb-1">
  {TEXT.linkCategory}
</label>
<select
  className="
  w-full
  px-3 py-2.5
  border border-gray-300
  rounded-lg
  text-sm
  bg-white
  focus:outline-none
  focus:ring-2
  focus:ring-black/10
"
      value={editModal.data.link_target}
      onChange={(e) =>
        setEditModal({
          ...editModal,
          data: { ...editModal.data, link_target: e.target.value },
        })
      }
    >
      <option value="">{TEXT.selectCategory}</option>
      {categories.map((c) => (
        <option key={c.id} value={c.slug}>
          {lang === "AR" ? c.name_ar : c.name_en}({c.slug})
        </option>
      ))}
    </select>
  </>
)}

      </div>
      {/* ACTIONS */}
      <div className="
  px-6 py-4
  border-t border-gray-200
  flex justify-between items-center
  bg-white
  sticky bottom-0
">
        <button
          className="
    text-[11px] sm:text-[12px]
    px-3 py-1.5
    rounded-lg
    border border-gray-300
    hover:bg-gray-50
  "
          onClick={() => setEditModal(null)}
        >
          {TEXT.cancel}
        </button>

        <button
          className="
    text-[11px] sm:text-[12px]
    px-4 py-1.5
    rounded-md
    bg-black text-white
     font-medium
    hover:bg-gray-800
    transition
  "
          onClick={async () => {
            if (editModal.type === "headerOverlayImages") {
  await updateAdminHeaderOverlayImages(editModal.data);

  const fresh = await getAdminHeaderOverlayImages();
  setHeaderOverlayImages(fresh);

  setEditModal(null);
  showToast(TEXT.success);
  return;
}
if (editModal.type === "categoryProductRows") {
  await updateAdminHomepageCategoryProductRows({
    rows: (editModal.data.rows || []).map((row, index) => ({
      category_id: Number(row.category_id),
      sort_order: index + 1,
      product_ids: Array.isArray(row.product_ids)
        ? row.product_ids.map(Number).filter(Boolean)
        : [],
    })),
  });

  const fresh = await getAdminHomepageCategoryProductRows();
  setCategoryProductRows(Array.isArray(fresh) ? fresh : []);

  setEditModal(null);
  showToast(TEXT.success);
  return;
}

            if (editModal.type === "searchOverlay") {
  await updateAdminSearchOverlaySettings({
    popular_terms: editModal.data.popular_terms || [],
    product_ids: editModal.data.product_ids || [],
  });

  const fresh = await getAdminSearchOverlaySettings();
  setSearchOverlaySettings(fresh);

  setEditModal(null);
  showToast(TEXT.success);
  return;
}

if (editModal.type === "productInstagramReels") {
  await updateAdminProductInstagramReelsSection(editModal.data);

  const fresh = await getAdminProductInstagramReelsSection();
  setProductInstagramReels(fresh);

  setEditModal(null);
  showToast(TEXT.success);
  return;
}

if (editModal.type === "productLookSection") {
  await updateAdminProductLookSection({
    title_en: editModal.data.title_en,
    title_ar: editModal.data.title_ar,
    product_ids: [],
  });

  const fresh = await getAdminProductLookSection();
  setProductLookSection(fresh);

  setEditModal(null);
  showToast(TEXT.success);
  return;
}

            if (editModal.type === "paymentDeliveryPage") {
  await updateAdminPaymentDeliverySettings(editModal.data);

  const fresh = await getAdminPaymentDeliverySettings();
  setPaymentDeliverySettings(fresh);

  setEditModal(null);
  return;
}

if (editModal.type === "returnsPage") {
  await updateAdminReturnsPageSettings(editModal.data);

  const fresh = await getAdminReturnsPageSettings();
  setReturnsSettings(fresh);

  setEditModal(null);
  return;
}

            if (editModal.type === "termsPage") {
  await updateAdminTermsConditionsSettings(editModal.data);

  const fresh = await getAdminTermsConditionsSettings();
  setTermsSettings(fresh);

  setEditModal(null);
  return;
}

if (editModal.type === "productsPageFeatured") {
  await updateAdminProductsPageFeaturedSection(editModal.data);

  const fresh = await getAdminProductsPageFeaturedSection();
  setProductsPageFeatured(fresh);

  setEditModal(null);
  showToast(TEXT.success);
  return;
}

if (editModal.type === "privacyPage") {
  await updateAdminPrivacyPolicySettings(editModal.data);

  const fresh = await getAdminPrivacyPolicySettings();
  setPrivacySettings(fresh);

  setEditModal(null);
  return;
}

if (editModal.type === "aboutPage") {
  await updateAdminAboutPageSettings(editModal.data);

  const fresh = await getAdminAboutPageSettings();
  setAboutPageSettings(fresh);

  setEditModal(null);
  return;
}

            if (editModal.type === "carouselTitle") {
  await updateAdminCategoryCarouselSection(editModal.data);

  setCategoryCarouselSection((prev) => ({
    ...prev,
    ...editModal.data,
  }));

  setEditModal(null);
  return;
}

            if (editModal.type === "carousel") {
  await updateAdminCategoryCarouselImage(editModal.data.id, {
    image_url: editModal.data.image_url,
  });

  setCarouselCategories((prev) =>
    prev.map((c) =>
      c.id === editModal.data.id ? { ...c, image_url: editModal.data.image_url } : c
    )
  );

  setEditModal(null);
  return;
}


if (editModal.type === "card") {
  const cardPayload = {
    ...editModal.data,
    title_en: editModal.data.title_en || "Slider",
    title_ar: editModal.data.title_ar || "سلايدر",
  };

  if (editModal.isNew) {
    await createAdminCategoryCard(cardPayload);
    setCategoryCards(await getAdminCategoryCards());
  } else {
    await updateAdminCategoryCard(
      editModal.data.id,
      cardPayload
    );

    setCategoryCards((prev) =>
      prev.map((c) =>
        c.id === editModal.data.id
          ? { ...c, ...cardPayload }
          : c
      )
    );
  }
}

            setEditModal(null);
          }}
        >
          {TEXT.save}
        </button>
       </div> 
    </div>
  </div>
)}

{confirm && (
  <div className="fixed inset-0 bg-black/40 z-50 flex items-end sm:items-center justify-center">
    <div className="bg-white rounded-2xl p-6 shadow-[0_20px_60px_rgba(0,0,0,0.25)]">
      <p className="text-gray-800 text-center mb-6">
        {confirm.message}
      </p>

      <div className="flex justify-center gap-4">
        <button
          className="px-3 py-2 sm:px-4 rounded-md border border-gray-300"
          onClick={() => setConfirm(null)}
        >
          {TEXT.cancel}
        </button>

        <button
          className="px-3 py-2 sm:px-4 rounded-xl bg-red-600 text-white"
          onClick={confirm.onConfirm}
        >
          {TEXT.confirm}
        </button>
      </div>
    </div>
  </div>
)}

{toast && (
  <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50">
    <div className="bg-black text-white hover:bg-gray-800 px-6 py-4 rounded-xl shadow-lg animate-fadeIn">
      {toast}
    </div>
  </div>
)}


</div>
                </main>
            </div>
        </div>
    );
}

export default AdminSettings;
